// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-16T17:34:00.448Z
// Property: THE'68 at Hemisfair (ID: 6767906449167664)
// Collections: 84 amenities, 4 floorplans (live), 39 photos, 73 POIs, 5 reviews, 3 virtual tours, 6 office hours, 1 special offers (live), 6 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162466",
  "multihub_property_id": "6767906449167664",
  "property_external_id": "2101272",
  "property_zillow_url": "https://www.zillow.com/apartments/san-antonio-tx/the'68/CkBMnv/",
  "property_apartments_url": "https://www.apartments.com/the68-san-antonio-tx/314c83d/",
  "property_google_business_url": "https://www.google.com/maps/place/THE%E2%80%9968/@29.4195391,-98.4866123,997m/data=!3m2!1e3!4b1!4m6!3m5!1s0x865c59cacf9d4f37:0x2c9dd9972f3c9703!8m2!3d29.4195391!4d-98.4866123!16s%2Fg%2F11fhw8cq2c?entry=ttu&g_ep=EgoyMDI2MDgxNy4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57322532164",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "2101272\np2068518",
  "property_status": null,
  "property_slug": "the'68-at-hemisfair",
  "property_name": "THE'68 at Hemisfair",
  "property_website_url": "https://www.the68hemisfair.com",
  "property_domain": "https://www.the68hemisfair.com",
  "property_address": "623 Hemisfair Blvd",
  "property_full_address": "623 Hemisfair Blvd, San Antonio, TX 78205",
  "property_address_1": "623 Hemisfair Blvd",
  "property_address_2": null,
  "property_address_city": "San Antonio",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "78205",
  "property_address_country": "US",
  "property_address_county": "Bexar County",
  "property_neighborhood_address": "Hemisfair",
  "property_address_latitude": "29.4192173",
  "property_address_longitude": "-98.48681520000001",
  "property_email": "THE68Manager@mox.living",
  "property_phone": "(866) 890-8982",
  "property_call_tracking_phone": "210-960-8183",
  "property_company_name": "Mox",
  "property_company_url": "https://www.mox.living/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "<p><strong>Modern downtown apartments in the heart of Hemisfair.</strong> Explore studio, one-, and two-bedroom <a href=\"/floor-plans\">floor plans</a> with city-framing windows, polished finishes, and access to standout shared spaces—then <a href=\"/schedule-a-tour\">schedule a tour</a> to see THE'68 up close.</p>",
  "property_long_description": "Welcome to THE'68 Apartments at Hemisfair, a luxury apartment community in the heart of Downtown San Antonio, Texas. Located at Hemisfair, our pet-friendly apartments offer studio, one, and two-bedroom floor plans ranging from 465 to 1,638 square feet, with modern finishes, granite countertops, energy-efficient appliances, and select homes featuring stunning views of downtown San Antonio.THE'68 is proud to be one of San Antonio's most pet-friendly apartment communities, with no breed or weight restrictions for your four-legged family members. We also waive the pet fee for animals adopted from an animal shelter, making it easier to find your new home together. With Hemisfair Park, Yanaguana Garden, dining, entertainment, and the best of downtown San Antonio just steps away, THE'68 offers a connected urban lifestyle where you and your pets can feel at home.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1b-0810-76a9-a470-46cfabd22268.webp",
  "property_featured_image_media": {
    "alt_text": "Modern lobby with hanging chairs and seating area.",
    "public_id": "019ffd1b-0810-76a9-a470-46cfabd22268",
    "storage_key": "property/6767906449167664/019ffd1b-0810-76a9-a470-46cfabd22268.webp",
    "width": 2000,
    "height": 1333
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "151",
  "property_year_built": "2019",
  "property_year_renovated": null,
  "property_walk_score": "84",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.06622516556291",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $150-300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "0",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "We are proud partners with PetScreening.com! Pet rents range; please contact the office for details on rents and size/breed restrictions.",
  "property_pet_policy_description": "We understand that pets are part of the family. That's why your pets are welcome to join our community at The '68 Apartments.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://the68hemisfair.securecafeapplicant.com/onlineleasing/content3/access/the-68-151-92-635/login",
  "property_resident_portal_url": "https://the68hemisfair.securecafenet.com/residentservices/the-68-151-92-635/userlogin",
  "property_apply_now_url": "https://the68hemisfair.securecafeapplicant.com/onlineleasing/content3/access/the-68-151-92-635/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025da-3edc-74fd-b1e8-28ff4fde1b2d.webp",
  "property_primary_logo_media": {
    "alt_text": "THE '68 Apartments at Hemisfair logo",
    "public_id": "01a025da-3edc-74fd-b1e8-28ff4fde1b2d",
    "storage_key": "property/6767906449167664/01a025da-3edc-74fd-b1e8-28ff4fde1b2d.webp",
    "width": 1000,
    "height": 382
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025da-3e2b-74ce-83a5-e6d684608938.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Sixty Eight Apartments at Hemisfair logo",
    "public_id": "01a025da-3e2b-74ce-83a5-e6d684608938",
    "storage_key": "property/6767906449167664/01a025da-3e2b-74ce-83a5-e6d684608938.webp",
    "width": 1226,
    "height": 203
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025da-f53b-771f-85fe-99dc65f330fd.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "01a025da-f53b-771f-85fe-99dc65f330fd",
    "storage_key": "property/6767906449167664/01a025da-f53b-771f-85fe-99dc65f330fd.webp",
    "width": 1000,
    "height": 382
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025da-e926-70dc-aa14-ac07730feb2c.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "01a025da-e926-70dc-aa14-ac07730feb2c",
    "storage_key": "property/6767906449167664/01a025da-e926-70dc-aa14-ac07730feb2c.webp",
    "width": 1000,
    "height": 382
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0b110-11a0-73bb-ba59-e09d0fa98a78.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0105a-2d11-75c8-b1a7-2269011410e5.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0b10f-c4d1-77d8-b6d1-8c4ee1490c37.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162466/01a0105a-2d11-75c8-b1a7-2269011410e5.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#574760",
  "property_secondary_color": "#a6985b",
  "property_font_color": null,
  "property_color_4": "#ffffff",
  "property_color_3": "#11252e",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 2",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "465 - 1638",
  "property_sqft_min": "465",
  "property_sqft_max": "1638",
  "property_price_range": "1131 - 4258",
  "property_price_min": "1131",
  "property_price_max": "4258",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/the68apartments",
  "property_instagram_url": "https://www.instagram.com/the68.sa/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJN0-dz8pZXIYRA5c8L5fZnSw",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to THE'68 at Hemisfair",
  "property_home_romance_title": "Embrace Comfort and Connection in Your Perfect Apartment Home",
  "property_home_amenities_blurb": "<p><strong>From rooftop play to pause, amenities at THE'68 at Hemisfair cover real ground.</strong> Recharge in our amazing fitness center, take on basketball or pickleball with a skyline backdrop, or settle into the business center. Garage parking, bike storage, gated electronic entry, on-site management, storage options, WiFi, pet spa access, and on-site spots to dine, sip, and grab dessert bring downtown San Antonio convenience right to the building.</p>",
  "property_home_floorplans_blurb": "<p><strong>Studios, one-bedrooms, and two-bedrooms with downtown polish.</strong> Choose a layout at THE'68 at Hemisfair that fits the way the space needs to function, from efficient footprints to roomier plans. Inside, select homes feature polished concrete or hardwood-style flooring, high ceilings, granite countertops, generous closets, in-home laundry features, balconies, city views, walk-in showers, or floor-to-ceiling windows—all in the heart of Hemisfair.</p>",
  "property_home_gallery_blurb": "<p><strong>See THE'68 at Hemisfair from every angle.</strong> Preview bright interiors with granite counters, sleek appliances, high ceilings, and wide windows, then take in the community spaces that set this Hemisfair address apart: a sunny rooftop deck, energizing fitness center, and rooftop basketball and pickleball court with skyline views built into the play.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Hemisfair starts at your doorstep.</strong> From THE'68 at Hemisfair, coffee at Box St. All Day, pizza at Dough, pours at Re:Rooted 210, and scoops from Lick Honest Ice Creams are all part of the daily map. Civic Park adds the Great Lawn, The Springs, shaded paths, public art, patios, and festival energy—linking you to Yanaguana Garden, downtown, Southtown, and the River Walk with every step.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents have plenty to say about THE’68 at Hemisfair.</strong> Reviews highlight polished spaces, responsive management, quick maintenance, bright apartments, standout views, secure garage access, a well-equipped fitness space, and rooftop courts. The Hemisfair location earns just as much praise, with dining, downtown, and Southtown close by. See what residents share in their own words.</p>",
  "property_neighborhood_blurb": "<p><strong>Start with the map, then step into it.</strong> Around THE'68, Hemisfair feels less like a landmark and more like your everyday route—morning coffee at Box St. All Day, Neapolitan pizza at Dough, a glass at Re:Rooted 210, or a scoop from Lick Honest Ice Creams just beyond the lobby.</p><p>Civic Park brings the neighborhood’s rhythm into focus with the Great Lawn, The Springs, and a Mexican Sycamore-lined promenade that connects to Yanaguana Garden and points you toward downtown, Southtown, and the River Walk. Public art, shaded paths, patios, festivals, and quick bites give each block a reason to linger. Explore the map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how this Hemisfair address puts San Antonio’s park-district energy right outside your door.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenity spaces with real range.</strong> At THE'68 at Hemisfair, your day can move from a streetside reset to a fitness session, a rooftop basketball or pickleball game, or a quiet stretch in the business center without leaving the building. The community pairs downtown energy with everyday ease: garage parking, bike storage, gated electronic entry, on-site management, storage options, recycling, WiFi access, and places to dine, sip, and grab dessert right at home.</p><p>Inside, your apartment keeps the look clean and modern with concrete or hardwood-style floors, high ceilings, granite countertops, efficient appliances, generous closets, and select floor-to-ceiling windows, balconies, and city views. Pet-friendly details like the pet spa and relief station add even more convenience—review the pet policy, browse the amenity gallery, or schedule a tour to see how it all connects.</p>",
  "property_applynow_blurb": "<p><strong>Your downtown San Antonio apartment starts here.</strong> At THE'68 at Hemisfair, modern studio, one-, and two-bedroom layouts pair polished concrete floors, high ceilings, granite countertops, in-home laundry features, and expansive city-framing windows with a connected Hemisfair setting. Ready to make it yours? Start your online application today.</p>",
  "property_contactus_blurb": "<p><strong>Questions about THE'68 at Hemisfair?</strong></p><p>Connect with the leasing team for help with apartment details, availability, or directions to our modern downtown San Antonio apartments in the heart of Hemisfair.</p>",
  "property_faqs_blurb": "<p><strong>Questions about THE’68?</strong> Start here for quick answers on the community, leasing, apartment features, and everyday living in the heart of Hemisfair. If you need more detail, the <a href=\"/contact-us\">leasing team</a> is happy to help you take the next step.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that matches your everyday rhythm.</strong> At THE'68, available floor plans range from efficient studios to roomy one- and two-bedroom apartments in Hemisfair, giving you options for a streamlined home base, a more defined work-from-home setup, or extra space to spread out.</p><p>As you compare layouts, look for the details that make each residence feel finished from day one: polished concrete or hardwood-style flooring, high ceilings, granite countertops, efficient appliances, generous closets, in-home laundry features, and select city views, balconies, walk-in showers, or floor-to-ceiling windows. Browse current pricing and availability, explore more <a href=\"/amenities\">apartment features</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see which floor plan feels right in person.</p>",
  "property_gallery_blurb": "<p><strong>Picture the view before you visit.</strong> THE'68 at Hemisfair photo gallery brings the building into focus through bright interiors, clean modern finishes, and the everyday scenes that make this Hemisfair address feel connected from the moment you arrive.</p><p>Scroll through kitchens with granite counters and sleek appliances, living areas framed by high ceilings and wide windows, and bedrooms that keep the look simple, polished, and calm. Then step into the community side: a roof deck made for sunny pauses, a fitness center with city energy in the background, and a rooftop basketball and pickleball court that turns the skyline into part of the game. As you browse, compare the spaces you like most with the full amenity collection, explore virtual tours, or schedule a tour to see the details in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Explore THE'68 at Hemisfair on the map.</strong></p><p>Find available apartments in the heart of Hemisfair, then zoom out to see how Yanaguana Garden, downtown energy, green space, dining, art, events, and skyline views connect around your everyday backdrop.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly living, minus the extra hassle.</strong> At THE'68, your four-legged routine has practical perks built in—from an on-site pet-washing station and pet-relief station to elevator access that makes quick outings simpler. When it’s time to stretch beyond the building, Hemisfair gives you leashed walks, open lawn moments, shaded seating, and Mutt Mitt stations close to home.</p><p>After a rinse at the pet spa or a stroll through the park district, settle back into a modern apartment with easy-care finishes and room to unwind. Review current pet rent, size, and breed guidelines with the leasing team, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how pet-friendly downtown San Antonio living works at THE'68.</p>",
  "property_referafriend_blurb": "<p><strong>Love life at THE'68 at Hemisfair?</strong> Share the downtown energy, skyline views, modern apartment finishes, and Hemisfair park-district setting with someone who should experience it, too. Use the referral form to invite a friend to make THE'68 at Hemisfair their next San Antonio address.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at THE'68 at Hemisfair.</strong></p><p>Log in to pay rent, submit maintenance requests, and manage your account—so everyday details stay as streamlined as your downtown San Antonio home in the heart of Hemisfair.</p>",
  "property_reviews_blurb": "<p><strong>Hear what residents love about THE'68.</strong> Reviews point to a polished, well-kept setting, responsive management, and maintenance that’s quick to help when requests come up. Residents also call out the everyday perks that make life here feel easy: bright apartments, standout views, secure garage access, a well-equipped fitness space, and rooftop courts among the <a href=\"/amenities\">community amenities</a>.</p><p>Most of all, reviewers highlight the energy of Hemisfair living—“amazing views and in the middle of all the action,” with dining, downtown, and Southtown within easy reach. Read the reviews below to see how residents describe the experience in their own words.</p>",
  "property_created_at": "1786657783210",
  "property_scheduletour_blurb": "<p><strong>See downtown living from THE'68 at Hemisfair.</strong> Tour streamlined studio, one-, and two-bedroom apartments with polished concrete floors, high ceilings, granite countertops, and expansive city-framing windows—then step into the amenity spaces that bring Hemisfair energy home. Schedule your tour today.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you — your inquiry has been received.</strong></p><p>Our leasing team will follow up soon. In the meantime, picture downtown San Antonio living with polished modern interiors, expansive city-framing windows, and Hemisfair’s park energy right outside your door at THE'68 at Hemisfair.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the layouts before you walk the building.</strong> These virtual tours let you move through THE'68 at Hemisfair on your schedule, from the streamlined studio with optional Ori system to the one-bedroom layout and the spacious two-bedroom, two-bath apartment. Pause where it matters: kitchen sightlines, closet placement, bathroom flow, natural light, and how each room connects as you move through the space.</p><p>As you tour, look for the modern finishes that give these apartments their clean downtown edge—polished concrete, high ceilings, sleek appliances, granite countertops, and wide windows in select homes. When a layout starts to feel right, compare it with current <a href=\"/floor-plans\">floor plan availability</a>, browse the <a href=\"/gallery\">photo gallery</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience THE'68 in person.</p>",
  "property_copyright": "2026 All Rights Reserved. THE'68",
  "property_seo_title_home": "THE'68 at Hemisfair | Apartments in San Antonio, TX",
  "property_seo_description_home": "Welcome to THE'68 at Hemisfair, where modern living meets vibrant amenities! Enjoy spacious floor plans, a fitness center, rooftop views, dining, and more in San Antonio!",
  "property_seo_title_floorplans": "Floor Plans | San Antonio, TX Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at THE'68 at Hemisfair in San Antonio, TX! Choose from stylish studios, spacious one, and two-bedroom apartments that fit your lifestyle perfectly.",
  "property_seo_title_amenities": "Amenities | San Antonio, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover vibrant living at THE'68 at Hemisfair in San Antonio! Enjoy luxury amenities, spacious layouts, and pet-friendly features for modern lifestyles.",
  "property_seo_title_gallery": "Gallery | Apartments in San Antonio, TX",
  "property_seo_description_gallery": "Discover life at THE'68 at Hemisfair in San Antonio, TX. Stylish floor plans, premium amenities, and stunning city views await your dream home!",
  "property_seo_title_virtualtours": "Virtual Tours | THE'68 at Hemisfair Apartments",
  "property_seo_description_virtualtours": "Step into THE'68 at Hemisfair in San Antonio, TX! Take a virtual tour of our stylish studio, one-bedroom, and two-bedroom apartments. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | THE'68 at Hemisfair Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at THE'68 at Hemisfair in San Antonio, TX! Explore studio to two-bedroom options with great amenities using our interactive map.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in San Antonio, TX",
  "property_seo_description_neighborhood": "Uncover vibrant San Antonio living at THE'68 at Hemisfair! Check out local gems and essential hotspots right outside your door. Your next adventure awaits!",
  "property_seo_title_contact": "Contact Us | THE'68 at Hemisfair",
  "property_seo_description_contact": "Connect with the leasing team at THE'68 at Hemisfair in San Antonio! Inquire about our stylish studio, one-bedroom, and two-bedroom floor plans. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in San Antonio, TX",
  "property_seo_description_faqs": "Find answers to all your burning questions about THE'68 at Hemisfair in San Antonio! From amenities to pet policies, our FAQs page has you covered. Get informed today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in San Antonio, TX",
  "property_seo_description_reviews": "Discover THE'68 at Hemisfair in San Antonio! Explore resident reviews and see why our vibrant community, stunning amenities, and city views create unforgettable homes!",
  "property_seo_title_applynow": "Apply Now | Apartments in San Antonio, TX",
  "property_seo_description_applynow": "Experience elegance at THE'68 at Hemisfair in vibrant San Antonio. From spacious floor plans to exclusive amenities, your ideal urban retreat awaits. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | THE'68 at Hemisfair",
  "property_seo_description_residentaccess": "Login to THE'68 at Hemisfair resident portal for easy rent payments, maintenance requests, and community updates. Simplifying your San Antonio living experience awaits!",
  "property_seo_title_referafriend": "Refer A Friend | THE'68 at Hemisfair",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to THE'68 at Hemisfair in San Antonio, TX, and enjoy exclusive perks in your vibrant community. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | THE'68 at Hemisfair",
  "property_seo_description_scheduletour": "Experience life at THE'68 at Hemisfair in vibrant San Antonio, TX. Schedule your tour today and find your perfect home in a community designed for your lifestyle!",
  "property_seo_title_privacy": "Privacy Policy | THE'68 at Hemisfair",
  "property_seo_description_privacy": "Safeguarding your trust at THE'68 at Hemisfair in San Antonio. Learn how we protect your privacy while you enjoy luxury living. Your comfort is our priority!",
  "property_seo_title_accessibility": "Website Accessibility | THE'68 at Hemisfair",
  "property_seo_description_accessibility": "At THE'68 at Hemisfair in San Antonio, TX, we prioritize accessibility for all. Experience a community designed for everyone. Join us in fostering digital inclusion today!",
  "property_seo_title_sitemap": "Sitemap | THE'68 at Hemisfair",
  "property_seo_description_sitemap": "Uncover the vibrant lifestyle at THE'68 at Hemisfair in San Antonio, TX. Access our sitemap to navigate your future home and discover the amenities that await you!",
  "property_seo_title_thankyou": "Thank You | THE'68 at Hemisfair",
  "property_seo_description_thankyou": "Thank you for reaching out! Your interest in THE'68 at Hemisfair, San Antonio’s vibrant apartment community, is appreciated. We'll be in touch soon to assist you!",
  "property_seo_title_pets": "Pet Policy | Apartments in San Antonio, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1792171373084",
  "amenities": [
    {
      "id": "ec_819593e9e971608b26ba3580",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128972938",
      "title": "Club Discount",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2052a2f1be9cd21e9c7e1a00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128969728",
      "title": "Pool Access Through Spa Plaza San Antonio Hotel Exclusive Membership",
      "amount": "false",
      "description": "We do not have a pool on our actual property; however, we partner with the nearby Spa Plaza San Antonio hotel and spa to give residents an exclusive wellness perk. ($99 additional per month for membership - see our team for details))",
      "group": "Community",
      "is_featured": "1",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c20cd24a15f741bcc90a466c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489140",
      "title": "Off Street Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7740326e70e0c3aee279a7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489137",
      "title": "Historic Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1219fccf99681f4ce223fb69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489132",
      "title": "Spanish Speaking Staff",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_720c9719640a9f5a008136e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489131",
      "title": "Recycling",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9a8a0e15ee846a8a8e4341c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489130",
      "title": "Public Transportation",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a9c674a4879165c65a74adbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489128",
      "title": "Night Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46e9dc10b9fc94a33a0e2c30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489127",
      "title": "Housekeeping",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d11ad9920c27d06e1e4b0cc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489126",
      "title": "Elevator",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c9ad880e714ce075376918c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489123",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13d472a7614b7ea78b57e787",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489124",
      "title": "Group Exercise",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0f3fed036debff1154c4f26e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489122",
      "title": "Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c6db6db894750bf3c30abffa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489121",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73cee34b16b86157b75053b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489120",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e23f6f6b8c5b455b514bd2a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489119",
      "title": "Sundeck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dd79eee1d54bf5b235b2f384",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188472",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56d84d27133436786ad478f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188462",
      "title": "Bike Racks",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73d2777a1b9e2cbce4a273bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188459",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_610e4b36bfc2aebadc570ceb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188455",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ac4861b9c705a41fde3189fa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188453",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66b938b127604e2ddf65c0a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188454",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_16f3a877f0b2bb8697fa65b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989553",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4554cec0af372f840269bea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989554",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-0cce-762b-8cbd-eddf103e387c.webp",
      "amenity_image_media": {
        "alt_text": "A person runs on a treadmill in a modern gym with wood-paneled walls.",
        "public_id": "01a025de-0cce-762b-8cbd-eddf103e387c",
        "storage_key": "property/6767906449167664/01a025de-0cce-762b-8cbd-eddf103e387c.webp",
        "width": 1140,
        "height": 716
      },
      "amenity_image_alt_text": "Fitness center with treadmills and cable machines at THE'68 Apartments, San Antonio, 78205",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_819317dd05c6da1d327ef20b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989570",
      "title": "On-site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2e86c6aba30a537b267f1121",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989545",
      "title": "Parking Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3822d4e842b8cfa6efa8905b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989546",
      "title": "Bicycle Storage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0188ef6c949bb53312536cc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989549",
      "title": "Pet-Washing Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_73b4c5e211cb98874c4c6129",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989551",
      "title": "Pet-Relief Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_19bdab7cfb4792e4c3464875",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989552",
      "title": "Gated Electronic Entrance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01bfadea5d1d86241567baa6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989555",
      "title": "Rooftop Basketball/Pickleball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1c-7165-722c-877b-f31c22b5fed9.webp",
      "amenity_image_media": {
        "alt_text": "Rooftop sports court with basketball hoop at sunset.",
        "public_id": "019ffd1c-7165-722c-877b-f31c22b5fed9",
        "storage_key": "property/6767906449167664/019ffd1c-7165-722c-877b-f31c22b5fed9.webp",
        "width": 1140,
        "height": 760
      },
      "amenity_image_alt_text": "Rooftop sports court with basketball hoop at sunset at THE'68 Apartments, San Antonio, TX 78205",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_407aec3a4d2d71c9f1080746",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989556",
      "title": "Winery",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a28fbe5ff126aa6f9e414f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989564",
      "title": "Restaurant",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a82a150d6f191c9e9c416d7c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989568",
      "title": "Ice Creamery",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d7d80894fdb66416c8d1b00d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989569",
      "title": "Online Rental Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_84ce883162a522fd00ff523e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989571",
      "title": "Recycling Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d88047f023902bc9d68564ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989573",
      "title": "WiFi Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bea91365d8e3ab8078e5685d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989574",
      "title": "Onsite Storage Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc604dcc097d8b901f543785",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188450",
      "title": "On-site Dining",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_71298cb5d9cf951ec291e083",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188451",
      "title": "Restaurants",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7c80d803625e5cb4b4a9b56",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188452",
      "title": "Retail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5e8943e2fe8299fe716e0b39",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188460",
      "title": "Pickleball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4dc95778c4b9fcce99e5365d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188461",
      "title": "Pet Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56ea0843be7ee489a68ac219",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188471",
      "title": "City View",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_225eb77aed1f08785d0039b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188473",
      "title": "Downtown",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fcc7a5ef4d597f099b523b35",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188485",
      "title": "Concrete Floors",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8a5d08215aa46a6ed4314895",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188486",
      "title": "In Unit Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6a3f24d023e42c109203728a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188487",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_efaae2260ec88178fb0ebcf6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489129",
      "title": "Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_de8ffa933d222ea383f67aa2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489134",
      "title": "Convenience Store",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed3776ce5f0f1d5aa56c920f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489136",
      "title": "Rooftop Lounge",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56d0296673f68f2b54421993",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489148",
      "title": "24-Hour Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9696b7e759b5155f1e1470cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489154",
      "title": "Furnished*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f06a0e5c3ff90b078668ee3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188480",
      "title": "View",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_58d0af72556821fe9315824a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188477",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e3000b36062aebd9d6aae7e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188479",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1fd70524ca6b71c712b9cf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188474",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4c2e7aa35e201dc31c6bfd8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188475",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1f5f3ac26382c606fcce4e71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128051124",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c468e89e1bd894e8fd013cf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128051122",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_deb35e5938372a8547f60a4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128051123",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9af85a63a3d9843eb18d4a10",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128051120",
      "title": "Wheelchair Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01b2887b156d8d986c124c9d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128051121",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7653d3c0a0b3375756d534ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128051115",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4df8e12afd929f61057260af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128051116",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c3e565a5aff1f7a8e77e3be2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128051117",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da7dbd029fd487d88aa4605b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128051118",
      "title": "W/D Hookup",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_081d78a738b0457d092c9a2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989584",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1c-79de-7366-ac48-0f55d90666db.webp",
      "amenity_image_media": {
        "alt_text": "Interior view of apartment kitchen with pendant lights and city view from balcony.",
        "public_id": "019ffd1c-79de-7366-ac48-0f55d90666db",
        "storage_key": "property/6767906449167664/019ffd1c-79de-7366-ac48-0f55d90666db.webp",
        "width": 1140,
        "height": 760
      },
      "amenity_image_alt_text": "Dining area with pendant lighting and balcony view at THE'68 Apartments, San Antonio, Texas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4bf87d80a9ede42599cf992d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128051119",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_97e241c9544a95e673e6ac60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128051126",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_44f53c503b68fbf42681f378",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188476",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_37f85d969a3dddb81e9bea97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989580",
      "title": "Central Heating and AIr",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df28587d716d46a4d22aa272",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989582",
      "title": "City Views",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_56eab07c6201036889dc5fa5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989583",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-0dab-71eb-a658-2c8d14a7e424.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with island seating, black countertops, and a city view.",
        "public_id": "01a025de-0dab-71eb-a658-2c8d14a7e424",
        "storage_key": "property/6767906449167664/01a025de-0dab-71eb-a658-2c8d14a7e424.webp",
        "width": 1140,
        "height": 760
      },
      "amenity_image_alt_text": "Kitchen island with bar seating and pendant lighting at THE'68 Apartments, San Antonio, TX",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6bb72415db87980e52768cb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989585",
      "title": "Furnished Apartment Available via Ori System*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c0d0c5da054373fd30dc607c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989591",
      "title": "Furniture Rental Services Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_767d351c3bf8a2fda9ac1b12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989594",
      "title": "High-Speed Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_970d1b9bb43dea57f976cabe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989596",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2a4400fc657fc847ff35e02b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989610",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d4f75b54748bcdbe5d7a9759",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "124989615",
      "title": "Walk-In Showers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1c-7f63-7199-86bb-c2b56f384c06.webp",
      "amenity_image_media": {
        "alt_text": "Modern bathroom with a walk-in shower, vanity, and storage.",
        "public_id": "019ffd1c-7f63-7199-86bb-c2b56f384c06",
        "storage_key": "property/6767906449167664/019ffd1c-7f63-7199-86bb-c2b56f384c06.webp",
        "width": 1140,
        "height": 760
      },
      "amenity_image_alt_text": "Modern bathroom with wood vanity and glass shower at THE'68 Apartments, San Antonio",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30268e5c10d3c063f3100c9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489026",
      "title": "Polished Concrete",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7d33429bbefe512e335b4ff4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128188481",
      "title": "Floor to Ceiling Windows*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_90e0ff456fe4ae8f212feeb8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489153",
      "title": "10.5 Foot Ceilings*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5b6dd8374fb1e6352de5d155",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "yardi",
      "external_id": "128489156",
      "title": "Tower of The Americas View*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_7a85707c5ada53f786f460ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025dd-fd07-765d-b4c0-9ab0ff1988ad.webp",
      "image_media": {
        "alt_text": "Woman walking into the lobby of a modern apartment building.",
        "public_id": "01a025dd-fd07-765d-b4c0-9ab0ff1988ad",
        "storage_key": "property/6767906449167664/01a025dd-fd07-765d-b4c0-9ab0ff1988ad.webp",
        "width": 2048,
        "height": 1216
      },
      "title": "Community",
      "description": "Welcome to your new home! Explore the stylish and modern lobby of our apartment community.",
      "link": "false",
      "alt_text": "Woman walking into the lobby of a modern apartment building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68-lobby 2.jpg"
    },
    {
      "id": "ec_883378e39b5d2d7ceadff02f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-19bb-767e-a19f-983d734f9c21.webp",
      "image_media": {
        "alt_text": "Person running on a treadmill in a modern gym with wood-paneled walls and various weight machines.",
        "public_id": "01a025de-19bb-767e-a19f-983d734f9c21",
        "storage_key": "property/6767906449167664/01a025de-19bb-767e-a19f-983d734f9c21.webp",
        "width": 1440,
        "height": 904
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills, free weights, and strength training machines.",
      "link": "false",
      "alt_text": "Person running on a treadmill in a modern gym with wood-paneled walls and various weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68-gym.jpg"
    },
    {
      "id": "ec_60d018beaf48d63da5b8701f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-1ccf-716d-ae07-4a8e6c3753fc.webp",
      "image_media": {
        "alt_text": "Children playing on a modern playground with unique climbing structures and seating.",
        "public_id": "01a025de-1ccf-716d-ae07-4a8e6c3753fc",
        "storage_key": "property/6767906449167664/01a025de-1ccf-716d-ae07-4a8e6c3753fc.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our state-of-the-art playground, featuring innovative climbing nets, engaging play structures, and comfortable seating areas for families.",
      "link": "false",
      "alt_text": "Children playing on a modern playground with unique climbing structures and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/15007_p_n45_board.jpg"
    },
    {
      "id": "ec_8bfaeebba0cdbb089ab5dbbd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-1b07-71e1-8b9b-87fd698bc17e.webp",
      "image_media": {
        "alt_text": "Modern lobby with hanging chairs and an orange bench.",
        "public_id": "01a025de-1b07-71e1-8b9b-87fd698bc17e",
        "storage_key": "property/6767906449167664/01a025de-1b07-71e1-8b9b-87fd698bc17e.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax in style in our modern lobby, featuring comfortable hanging chairs and a stylish orange bench. Perfect for waiting or socializing.",
      "link": "false",
      "alt_text": "Modern lobby with hanging chairs and an orange bench.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68-lobby.jpg"
    },
    {
      "id": "ec_399a0ed990be4b472c9341e1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-1ba4-724b-86b9-fc4cf6c51a86.webp",
      "image_media": {
        "alt_text": "Modern outdoor climbing structure with reflective canopy and rope net.",
        "public_id": "01a025de-1ba4-724b-86b9-fc4cf6c51a86",
        "storage_key": "property/6767906449167664/01a025de-1ba4-724b-86b9-fc4cf6c51a86.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy active fun at our community's unique climbing structure, featuring a reflective canopy and challenging rope net for all ages.",
      "link": "false",
      "alt_text": "Modern outdoor climbing structure with reflective canopy and rope net.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/15007_p_n42_board.jpg"
    },
    {
      "id": "ec_114ece1e8ad9507de92d5a6c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-1a48-730b-a683-983602132851.webp",
      "image_media": {
        "alt_text": "People at a bar and behind the bar",
        "public_id": "01a025de-1a48-730b-a683-983602132851",
        "storage_key": "property/6767906449167664/01a025de-1a48-730b-a683-983602132851.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "This image shows a bar area with people sitting at the counter and bartenders preparing drinks. The decor is industrial with exposed pipes and concrete walls.",
      "link": "false",
      "alt_text": "People at a bar and behind the bar",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/15007_p_n59_board.jpg"
    },
    {
      "id": "ec_eaef0b45eb12cd1cab11ee6b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-2bfa-7559-83a0-a1dcc6624ed8.webp",
      "image_media": {
        "alt_text": "Children playing on a unique merry-go-round and a wooden playhouse in a community courtyard with apartment buildings in the background.",
        "public_id": "01a025de-2bfa-7559-83a0-a1dcc6624ed8",
        "storage_key": "property/6767906449167664/01a025de-2bfa-7559-83a0-a1dcc6624ed8.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at our community's vibrant play area, featuring a modern merry-go-round and a charming wooden playhouse, set against the backdrop of our apartment buildings.",
      "link": "false",
      "alt_text": "Children playing on a unique merry-go-round and a wooden playhouse in a community courtyard with apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/15007_p_n41_board.jpg"
    },
    {
      "id": "ec_05dece305950dceb09d923b5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-2daa-722f-9aba-2d54a5497ca5.webp",
      "image_media": {
        "alt_text": "Colorful mural on building exterior with outdoor seating area and people dining.",
        "public_id": "01a025de-2daa-722f-9aba-2d54a5497ca5",
        "storage_key": "property/6767906449167664/01a025de-2daa-722f-9aba-2d54a5497ca5.webp",
        "width": 1334,
        "height": 2000
      },
      "title": "Community",
      "description": "Vibrant mural adorns the exterior of the building, complemented by a welcoming outdoor seating area where residents can relax and dine.",
      "link": "false",
      "alt_text": "Colorful mural on building exterior with outdoor seating area and people dining.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/15007_p_n40_board.jpg"
    },
    {
      "id": "ec_461846a2a110c66b888d24f7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-2b18-76da-a872-8cb38c9b69b0.webp",
      "image_media": {
        "alt_text": "Stylish restaurant with people dining, large windows, and tropical mural.",
        "public_id": "01a025de-2b18-76da-a872-8cb38c9b69b0",
        "storage_key": "property/6767906449167664/01a025de-2b18-76da-a872-8cb38c9b69b0.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy a meal at our vibrant restaurant, featuring chic decor, abundant natural light, and a lively atmosphere perfect for any occasion.",
      "link": "false",
      "alt_text": "Stylish restaurant with people dining, large windows, and tropical mural.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/15007_p_n39_board.jpg"
    },
    {
      "id": "ec_8a8a44a2003302cc0a95fbdb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-2cde-7127-8eb4-732128c39676.webp",
      "image_media": {
        "alt_text": "People dining at tables inside a wine-themed community space with barrels and art.",
        "public_id": "01a025de-2cde-7127-8eb4-732128c39676",
        "storage_key": "property/6767906449167664/01a025de-2cde-7127-8eb4-732128c39676.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Community",
      "description": "Enjoy the unique ambiance of our community space, featuring wine barrels and local art. Perfect for socializing or relaxing.",
      "link": "false",
      "alt_text": "People dining at tables inside a wine-themed community space with barrels and art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/15007_p_n38_board.jpg"
    },
    {
      "id": "ec_f513699f5d630a6cb466d642",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-2e9a-735e-bcd8-543f99db40bf.webp",
      "image_media": {
        "alt_text": "Modern lobby with chairs, a bench, and abstract art.",
        "public_id": "01a025de-2e9a-735e-bcd8-543f99db40bf",
        "storage_key": "property/6767906449167664/01a025de-2e9a-735e-bcd8-543f99db40bf.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Relax and unwind in our stylishly appointed community lounge, featuring comfortable seating and modern decor.",
      "link": "false",
      "alt_text": "Modern lobby with chairs, a bench, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68_styled-08.jpg"
    },
    {
      "id": "ec_64dd3fab0b6acc20e6746c10",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-3b07-7758-b237-6a1955f72e2e.webp",
      "image_media": {
        "alt_text": "A modern living room with minimalist decor, featuring a chair, bookshelf, and abstract art.",
        "public_id": "01a025de-3b07-7758-b237-6a1955f72e2e",
        "storage_key": "property/6767906449167664/01a025de-3b07-7758-b237-6a1955f72e2e.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Experience stylish urban living in this thoughtfully designed apartment, showcasing a chic living space with contemporary furnishings and curated decor.",
      "link": "false",
      "alt_text": "A modern living room with minimalist decor, featuring a chair, bookshelf, and abstract art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68_styled-13.jpg"
    },
    {
      "id": "ec_adcae1cc91cfac1fe7f41a57",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-3e90-7460-8cc4-eb43d618e1b5.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances and wood cabinets, adjacent to a bedroom.",
        "public_id": "01a025de-3e90-7460-8cc4-eb43d618e1b5",
        "storage_key": "property/6767906449167664/01a025de-3e90-7460-8cc4-eb43d618e1b5.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Chic kitchen featuring sleek black appliances, dark tile backsplash, and warm wood cabinetry, opening to a sunlit bedroom.",
      "link": "false",
      "alt_text": "Modern kitchen with black appliances and wood cabinets, adjacent to a bedroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68_styled-11.jpg"
    },
    {
      "id": "ec_7e58dfdad1297c71b4ada984",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1b-8434-7255-9d93-de7a4863ee82.webp",
      "image_media": {
        "alt_text": "Aerial view of an urban park with a modern playground and colorful buildings, overlooking a city skyline.",
        "public_id": "019ffd1b-8434-7255-9d93-de7a4863ee82",
        "storage_key": "property/6767906449167664/019ffd1b-8434-7255-9d93-de7a4863ee82.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Experience the vibrant city life and enjoy the recreational amenities of our community, featuring a modern playground and scenic park grounds.",
      "link": "false",
      "alt_text": "Aerial view of an urban park with a modern playground and colorful buildings, overlooking a city skyline.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/The 68_arieal.jpg"
    },
    {
      "id": "ec_184df425e16196deddc9b613",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-3f9c-73ae-8cee-68f77e4cb8d9.webp",
      "image_media": {
        "alt_text": "Woman on balcony, modern living room with abstract art and a dog.",
        "public_id": "01a025de-3f9c-73ae-8cee-68f77e4cb8d9",
        "storage_key": "property/6767906449167664/01a025de-3f9c-73ae-8cee-68f77e4cb8d9.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Lifestyle",
      "description": "Experience sophisticated urban living in this stylish apartment featuring a balcony, modern decor, and a playful pup.",
      "link": "false",
      "alt_text": "Woman on balcony, modern living room with abstract art and a dog.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68_Penthouse Eastview Living.jpg"
    },
    {
      "id": "ec_58367d99de984e0a60bddfab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1b-9fa3-76ab-8fc0-23ad22c7b07d.webp",
      "image_media": {
        "alt_text": "Modern apartment building with balconies, surrounded by lush greenery and a clear blue sky.",
        "public_id": "019ffd1b-9fa3-76ab-8fc0-23ad22c7b07d",
        "storage_key": "property/6767906449167664/019ffd1b-9fa3-76ab-8fc0-23ad22c7b07d.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Experience urban living in this stylish apartment building, featuring modern architecture and balconies, set amidst a beautifully landscaped community space.",
      "link": "false",
      "alt_text": "Modern apartment building with balconies, surrounded by lush greenery and a clear blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/The 68_5.jpg"
    },
    {
      "id": "ec_ac6b58bb6891283b6b41a5f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1b-704c-7580-bf45-ce306797afe9.webp",
      "image_media": {
        "alt_text": "Boho-chic outdoor seating area with hanging chairs in front of a colorful mural.",
        "public_id": "019ffd1b-704c-7580-bf45-ce306797afe9",
        "storage_key": "property/6767906449167664/019ffd1b-704c-7580-bf45-ce306797afe9.webp",
        "width": 2560,
        "height": 1704
      },
      "title": "Community",
      "description": "Relax and unwind in our vibrant community spaces, featuring unique art installations and comfortable outdoor seating.",
      "link": "false",
      "alt_text": "Boho-chic outdoor seating area with hanging chairs in front of a colorful mural.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/The 68_9.jpg"
    },
    {
      "id": "ec_1f508260bc3cf5d4e717d9c2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-5058-7349-9373-34890e2fd07c.webp",
      "image_media": {
        "alt_text": "Modern apartment building with a playground in the foreground.",
        "public_id": "01a025de-5058-7349-9373-34890e2fd07c",
        "storage_key": "property/6767906449167664/01a025de-5058-7349-9373-34890e2fd07c.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with our on-site playground, offering a fun space for all ages.",
      "link": "false",
      "alt_text": "Modern apartment building with a playground in the foreground.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/The 68_3.jpg"
    },
    {
      "id": "ec_6d274c1ed9632b5b0d294f4d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1b-6d28-77c7-b312-11449879cb44.webp",
      "image_media": {
        "alt_text": "Modern apartment living area with open kitchen and city views from balcony.",
        "public_id": "019ffd1b-6d28-77c7-b312-11449879cb44",
        "storage_key": "property/6767906449167664/019ffd1b-6d28-77c7-b312-11449879cb44.webp",
        "width": 2560,
        "height": 1708
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area featuring a modern kitchen with stainless steel appliances and a breakfast bar, leading to a balcony with city skyline views.",
      "link": "false",
      "alt_text": "Modern apartment living area with open kitchen and city views from balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68_Model Unit 4.jpg"
    },
    {
      "id": "ec_1d25e5f5c8fde3774e8164c7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1b-ab52-753c-a7bc-edf69d924534.webp",
      "image_media": {
        "alt_text": "Modern lobby with orange bench, large mirror, and decorative floor lamps.",
        "public_id": "019ffd1b-ab52-753c-a7bc-edf69d924534",
        "storage_key": "property/6767906449167664/019ffd1b-ab52-753c-a7bc-edf69d924534.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Welcome guests into a stylish and inviting lobby, featuring a contemporary orange bench, elegant floor lamps, and a large mirror that amplifies the space.",
      "link": "false",
      "alt_text": "Modern lobby with orange bench, large mirror, and decorative floor lamps.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/The 68_2.jpg"
    },
    {
      "id": "ec_9b2b134152378fd2ba53bb12",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1b-bf92-7676-87e4-f470c10eac7f.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black granite countertops, stainless steel appliances, and wood cabinets.",
        "public_id": "019ffd1b-bf92-7676-87e4-f470c10eac7f",
        "storage_key": "property/6767906449167664/019ffd1b-bf92-7676-87e4-f470c10eac7f.webp",
        "width": 2560,
        "height": 2115
      },
      "title": "Apartment",
      "description": "Step into a sleek and modern kitchen featuring high-end stainless steel appliances, elegant black granite countertops, and rich wood cabinetry. Perfect for culinary creations.",
      "link": "false",
      "alt_text": "Modern kitchen with black granite countertops, stainless steel appliances, and wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68_Model Unit 5.jpg"
    },
    {
      "id": "ec_c0c5dc3079fa2f4925e2b9c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1b-b17e-7610-a0cc-bd30eb7ea22d.webp",
      "image_media": {
        "alt_text": "Open concept living and dining area with large windows and modern art.",
        "public_id": "019ffd1b-b17e-7610-a0cc-bd30eb7ea22d",
        "storage_key": "property/6767906449167664/019ffd1b-b17e-7610-a0cc-bd30eb7ea22d.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Spacious open-concept living and dining area featuring floor-to-ceiling windows, contemporary art, and sleek, modern furniture.",
      "link": "false",
      "alt_text": "Open concept living and dining area with large windows and modern art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68_Penthouse Westview Living.jpg"
    },
    {
      "id": "ec_75e6cca8b15ffd62fe64aa5d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1b-c0be-72cd-b143-55a4ac12e9d6.webp",
      "image_media": {
        "alt_text": "Modern kitchen with a breakfast bar and sleek cabinets.",
        "public_id": "019ffd1b-c0be-72cd-b143-55a4ac12e9d6",
        "storage_key": "property/6767906449167664/019ffd1b-c0be-72cd-b143-55a4ac12e9d6.webp",
        "width": 2560,
        "height": 1708
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring a large island with bar stools, modern appliances, and a well-stocked bar area, perfect for entertaining.",
      "link": "false",
      "alt_text": "Modern kitchen with a breakfast bar and sleek cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68_Penthouse Kitchen.jpg"
    },
    {
      "id": "ec_cb65debace601bb8f1431b6d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1b-cb49-738a-a063-ce341388d2c2.webp",
      "image_media": {
        "alt_text": "Modern living room with view into a sleek kitchen with wood cabinetry and black appliances.",
        "public_id": "019ffd1b-cb49-738a-a063-ce341388d2c2",
        "storage_key": "property/6767906449167664/019ffd1b-cb49-738a-a063-ce341388d2c2.webp",
        "width": 2560,
        "height": 1708
      },
      "title": "Apartment",
      "description": "Step into this stylish apartment, featuring a seamless transition from the living area to a modern kitchen equipped with elegant wood cabinetry and sleek black appliances.",
      "link": "false",
      "alt_text": "Modern living room with view into a sleek kitchen with wood cabinetry and black appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68_Model Unit.jpg"
    },
    {
      "id": "ec_3a6e18510dde4de80cbbcadc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1b-d90d-747a-960d-2e44d1ae3ba6.webp",
      "image_media": {
        "alt_text": "Modern living room with large windows, sofa, and chairs.",
        "public_id": "019ffd1b-d90d-747a-960d-2e44d1ae3ba6",
        "storage_key": "property/6767906449167664/019ffd1b-d90d-747a-960d-2e44d1ae3ba6.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "A stylish and contemporary living space featuring ample natural light from floor-to-ceiling windows, comfortable seating, and modern decor, perfect for relaxation.",
      "link": "false",
      "alt_text": "Modern living room with large windows, sofa, and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/The 68_4.jpg"
    },
    {
      "id": "ec_ea06b2ab6c21be12b170f03e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1b-f45c-74cc-8d94-28aafde71537.webp",
      "image_media": {
        "alt_text": "Modern lounge area with Marilyn Monroe art and seating.",
        "public_id": "019ffd1b-f45c-74cc-8d94-28aafde71537",
        "storage_key": "property/6767906449167664/019ffd1b-f45c-74cc-8d94-28aafde71537.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, featuring iconic art and comfortable seating areas.",
      "link": "false",
      "alt_text": "Modern lounge area with Marilyn Monroe art and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/The 68_10.jpg"
    },
    {
      "id": "ec_5284d8bc5d76685f36e18ae2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1c-0bc0-7445-9fea-b94dae367eab.webp",
      "image_media": {
        "alt_text": "Modern seating area with yellow chairs, abstract rug, and elevator in multifamily property lobby.",
        "public_id": "019ffd1c-0bc0-7445-9fea-b94dae367eab",
        "storage_key": "property/6767906449167664/019ffd1c-0bc0-7445-9fea-b94dae367eab.webp",
        "width": 2560,
        "height": 1872
      },
      "title": "Community",
      "description": "Relax and unwind in this stylish seating area, conveniently located near the elevators. A perfect spot to wait or socialize.",
      "link": "false",
      "alt_text": "Modern seating area with yellow chairs, abstract rug, and elevator in multifamily property lobby.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/The 68_11.jpg"
    },
    {
      "id": "ec_1069d5ff0d184427a8bfc8df",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1c-0c1a-74e3-8688-76522022c87f.webp",
      "image_media": {
        "alt_text": "Bedroom with city view and modern decor",
        "public_id": "019ffd1c-0c1a-74e3-8688-76522022c87f",
        "storage_key": "property/6767906449167664/019ffd1c-0c1a-74e3-8688-76522022c87f.webp",
        "width": 2560,
        "height": 1653
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable bed, entertainment center, and a large window with a panoramic view of the city skyline.",
      "link": "false",
      "alt_text": "Bedroom with city view and modern decor",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68_Penthouse Master Bedroom.jpg"
    },
    {
      "id": "ec_73ef7f8fd2912ab1422e88c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1c-0b5f-728d-9294-3dc6dd0c7768.webp",
      "image_media": {
        "alt_text": "Modern bathroom with double vanity, walk-in shower, and city views.",
        "public_id": "019ffd1c-0b5f-728d-9294-3dc6dd0c7768",
        "storage_key": "property/6767906449167664/019ffd1c-0b5f-728d-9294-3dc6dd0c7768.webp",
        "width": 2560,
        "height": 1746
      },
      "title": "Apartment",
      "description": "Experience luxury living in this spacious bathroom, featuring a sleek double vanity, a refreshing walk-in shower, and large windows with breathtaking city views.",
      "link": "false",
      "alt_text": "Modern bathroom with double vanity, walk-in shower, and city views.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/68_Penthouse Bathroom.jpg"
    },
    {
      "id": "ec_df3e85ec8105dbbcc7244bca",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-885a-73ea-ae14-32eb48687ee2.webp",
      "image_media": {
        "alt_text": "Exterior of the Dough restaurant with a covered patio and tables.",
        "public_id": "01a025de-885a-73ea-ae14-32eb48687ee2",
        "storage_key": "property/6767906449167664/01a025de-885a-73ea-ae14-32eb48687ee2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy dining al fresco on the covered patio of the Dough restaurant, perfect for a casual meal or gathering with friends.",
      "link": "false",
      "alt_text": "Exterior of the Dough restaurant with a covered patio and tables.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/2019-09-10_NearbyRestaurant-Dough-Exterior.jpg"
    },
    {
      "id": "ec_f3c63450810458f05fd12322",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-9a00-7119-bde3-618939d5ccf2.webp",
      "image_media": {
        "alt_text": "Archway with greenery and trees in a sunny park.",
        "public_id": "01a025de-9a00-7119-bde3-618939d5ccf2",
        "storage_key": "property/6767906449167664/01a025de-9a00-7119-bde3-618939d5ccf2.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Community",
      "description": "Enjoy the beautiful outdoors with this charming archway, perfect for a leisurely stroll on a sunny day. Surrounded by lush greenery and vibrant trees.",
      "link": "false",
      "alt_text": "Archway with greenery and trees in a sunny park.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/2019-09-10_ParkWalkway-ArchTrellis.jpg"
    },
    {
      "id": "ec_da71f88cf1a9521bc03ae201",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-a3a4-735b-b413-fedc5e5fd428.webp",
      "image_media": {
        "alt_text": "Aerial view of a vibrant urban community with a playground and historic buildings.",
        "public_id": "01a025de-a3a4-735b-b413-fedc5e5fd428",
        "storage_key": "property/6767906449167664/01a025de-a3a4-735b-b413-fedc5e5fd428.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover a lively community atmosphere with a modern playground, charming historic architecture, and a bustling city skyline as your backdrop.",
      "link": "false",
      "alt_text": "Aerial view of a vibrant urban community with a playground and historic buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/2019-09-10_AerialView-DowntownSkyline-YanaguanaGarden.jpg"
    },
    {
      "id": "ec_067a05383e00b9ffb6bcd181",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-7368-766f-bd44-b97230f9c075.webp",
      "image_media": {
        "alt_text": "Modern apartment building with a playground and green trees under a blue sky.",
        "public_id": "01a025de-7368-766f-bd44-b97230f9c075",
        "storage_key": "property/6767906449167664/01a025de-7368-766f-bd44-b97230f9c075.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover modern living with this apartment building, featuring an on-site playground and lush greenery, perfect for outdoor enjoyment.",
      "link": "false",
      "alt_text": "Modern apartment building with a playground and green trees under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/2019-09-06_NearbyPark-Playground-TowerView.jpg"
    },
    {
      "id": "ec_f3e5a3b515cb00bf735eda50",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-711f-71d9-99ce-511a9b747f85.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with modern finishes.",
        "public_id": "01a025de-711f-71d9-99ce-511a9b747f85",
        "storage_key": "property/6767906449167664/01a025de-711f-71d9-99ce-511a9b747f85.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and modern living area with an open-concept kitchen, perfect for entertaining.",
      "link": "false",
      "alt_text": "Living room and kitchen area with modern finishes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/2019-09-06_LivingRoom-SideTable-KitchenView.jpg"
    },
    {
      "id": "ec_3c7b30382ae5db3c9b8bd2c7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-908b-73b8-8613-5cc52c374a07.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment building with brick facade and balconies.",
        "public_id": "01a025de-908b-73b8-8613-5cc52c374a07",
        "storage_key": "property/6767906449167664/01a025de-908b-73b8-8613-5cc52c374a07.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Community",
      "description": "Discover this stunning apartment building, featuring a contemporary brick exterior and private balconies, blending seamlessly with its urban surroundings.",
      "link": "false",
      "alt_text": "Exterior view of a modern apartment building with brick facade and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/2019-09-10_AerialDrone-BuildingExterior.JPG"
    },
    {
      "id": "ec_897eae31107acb4a673c01c8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-8ecf-76cd-bf62-7621f2b1005a.webp",
      "image_media": {
        "alt_text": "Framed HemisFair '68 poster above a bed.",
        "public_id": "01a025de-8ecf-76cd-bf62-7621f2b1005a",
        "storage_key": "property/6767906449167664/01a025de-8ecf-76cd-bf62-7621f2b1005a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Decorate your bedroom with this retro \"HemisFair '68\" poster from San Antonio, Texas, adding a touch of vintage charm to your space.",
      "link": "false",
      "alt_text": "Framed HemisFair '68 poster above a bed.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/2019-09-06_Bedroom-HeadboardHemisfairArt.jpg"
    },
    {
      "id": "ec_1578e1eadacaf92047d74f81",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-a4ec-7707-9a01-bc62398dab8b.webp",
      "image_media": {
        "alt_text": "Modern apartment living area with a woman on the balcony, artwork, and a small dog.",
        "public_id": "01a025de-a4ec-7707-9a01-bc62398dab8b",
        "storage_key": "property/6767906449167664/01a025de-a4ec-7707-9a01-bc62398dab8b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the stylish ambiance of this modern apartment, featuring a woman enjoying the view from the balcony, vibrant artwork, and a playful pup.",
      "link": "false",
      "alt_text": "Modern apartment living area with a woman on the balcony, artwork, and a small dog.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/2020-01-06_LivingArea-Penthouse-EastView.jpg"
    },
    {
      "id": "ec_4884c29717b345109a26d080",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-a5dd-73e1-b1c4-c267c113b670.webp",
      "image_media": {
        "alt_text": "Interior of an empty apartment with a modern kitchen and living area, overlooking a city skyline.",
        "public_id": "01a025de-a5dd-73e1-b1c4-c267c113b670",
        "storage_key": "property/6767906449167664/01a025de-a5dd-73e1-b1c4-c267c113b670.webp",
        "width": 2000,
        "height": 1334
      },
      "title": "Apartment",
      "description": "Spacious apartment featuring a sleek kitchen with wood cabinetry and stainless steel appliances, adjacent to a bright living area with large windows and a balcony offering city views.",
      "link": "false",
      "alt_text": "Interior of an empty apartment with a modern kitchen and living area, overlooking a city skyline.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/2019-09-06_The68Apartments-SanAntonio-TwoBedroom.jpg"
    },
    {
      "id": "ec_15a85c1937d46f5eb6332920",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a025de-a5f2-753e-a726-22d8355daf7e.webp",
      "image_media": {
        "alt_text": "Two hanging pod chairs with beige cushions in front of a wall with colorful vertical stripes.",
        "public_id": "01a025de-a5f2-753e-a726-22d8355daf7e",
        "storage_key": "property/6767906449167664/01a025de-a5f2-753e-a726-22d8355daf7e.webp",
        "width": 1887,
        "height": 1163
      },
      "title": "Community",
      "description": "Relax in style with these unique hanging pod chairs, perfect for a cozy reading nook or a pop of color in your community space.",
      "link": "false",
      "alt_text": "Two hanging pod chairs with beige cushions in front of a wall with colorful vertical stripes.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/85483/2019-09-06_IndoorLounge-HangingChairs-ColorfulWall.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_16c993d9-b396-457f-87f1-927160f26653",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Dough Pizzeria Napoletana",
      "poi_type": "Restaurants",
      "poi_address": "518 S Alamo St, San Antonio, TX 78205, USA",
      "poi_short_description": "Casual joint for classic Neapolitan-style pizza plus beer and wine.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-6a2f-75d5-a834-6593c3a2deba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-6a2f-75d5-a834-6593c3a2deba",
        "storage_key": "property/6767906449167664/019ffd1d-6a2f-75d5-a834-6593c3a2deba.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.doughpizzeria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2775982156169853470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dough-pizzeria-napoletana",
      "poi_latitude": "29.4186661",
      "poi_longitude": "-98.4880219",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-227-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ51lHiXZZXIYRHrpTMRBFhiY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_94363a98-acdc-45b7-a315-8ea7c882c28d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Schilo's",
      "poi_type": "Restaurants",
      "poi_address": "424 E Commerce St, San Antonio, TX 78205, USA",
      "poi_short_description": "Veteran German deli serving hearty sandwiches, soups, and homemade root beer in a 19th-century building.",
      "poi_long_description": "Veteran German deli serving hearty sandwiches, soups, and homemade root beer in a 19th-century building.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-6017-73be-9497-a10658aef8d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-6017-73be-9497-a10658aef8d6",
        "storage_key": "property/6767906449167664/019ffd1d-6017-73be-9497-a10658aef8d6.webp",
        "width": 881,
        "height": 1280
      },
      "poi_business_url": "https://www.schilos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15816658571755978074&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schilos",
      "poi_latitude": "29.42370499999999",
      "poi_longitude": "-98.48828600000002",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-223-6692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE3cua6tYXIYRWv0mtysPgNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_29d13f05-8b38-4437-915a-d5f084500443",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Boudro's on the Riverwalk",
      "poi_type": "Restaurants",
      "poi_address": "On The Riverwalk Level, 421 E Commerce St, San Antonio, TX 78205, USA",
      "poi_short_description": "Hip New American bistro with wood-grilled steaks, seafood, tableside guacamole, cocktails & a patio.",
      "poi_long_description": "Hip New American bistro with wood-grilled steaks, seafood, tableside guacamole, cocktails & a patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-5fd8-70e9-9d79-92f1abb4bf93.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-5fd8-70e9-9d79-92f1abb4bf93",
        "storage_key": "property/6767906449167664/019ffd1d-5fd8-70e9-9d79-92f1abb4bf93.webp",
        "width": 620,
        "height": 310
      },
      "poi_business_url": "http://www.boudros.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5434842793229321958&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boudros-on-the-riverwalk",
      "poi_latitude": "29.4240604",
      "poi_longitude": "-98.4883378",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-224-8484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdRSMP6tYXIYR5oaGtLlwbEs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bistro"
    },
    {
      "id": "custom_b4b623a7-2646-44f8-beeb-f414e2932432",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Casa Rio",
      "poi_type": "Restaurants",
      "poi_address": "430 E Commerce St, San Antonio, TX 78205, USA",
      "poi_short_description": "Pioneering River Walk destination with classic Tex-Mex fare, margaritas & outdoor dining since 1946.",
      "poi_long_description": "Pioneering River Walk destination with classic Tex-Mex fare, margaritas & outdoor dining since 1946.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-60d0-753a-a54d-69a3a38dc549.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-60d0-753a-a54d-69a3a38dc549",
        "storage_key": "property/6767906449167664/019ffd1d-60d0-753a-a54d-69a3a38dc549.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.casario.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2728289186931312478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "casa-rio",
      "poi_latitude": "29.42365909999999",
      "poi_longitude": "-98.4881348",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-225-6718",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJXa2QEqtYXIYRXoeUd4_U3CU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_6309cbb0-6f38-4bfc-a9dc-1954e5be9e3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Paesanos Riverwalk",
      "poi_type": "Restaurants",
      "poi_address": "111 W Crockett St Suite 101, San Antonio, TX 78205, USA",
      "poi_short_description": "Upscale destination with traditional & contemporary Italian fare, a long wine list & outdoor dining.",
      "poi_long_description": "Upscale destination with traditional & contemporary Italian fare, a long wine list & outdoor dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-696a-710b-b287-6a66bb8fc242.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-696a-710b-b287-6a66bb8fc242",
        "storage_key": "property/6767906449167664/019ffd1d-696a-710b-b287-6a66bb8fc242.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.paesanosriverwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11710448536429269479&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paesanos-riverwalk",
      "poi_latitude": "29.42536999999999",
      "poi_longitude": "-98.4889198",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-227-2782",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJw2ODlqxYXIYR5xFcNubeg6I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_c2f4608d-053e-46eb-b392-83db9c7330ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "The Esquire Tavern",
      "poi_type": "Restaurants",
      "poi_address": "155 E Commerce St, San Antonio, TX 78205, USA",
      "poi_short_description": "Inspired drinks & pub grub in vintage digs with a patio & the longest wooden bartop in Texas.",
      "poi_long_description": "Inspired drinks & pub grub in vintage digs with a patio & the longest wooden bartop in Texas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-695b-7048-86fb-80aefc11b474.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-695b-7048-86fb-80aefc11b474",
        "storage_key": "property/6767906449167664/019ffd1d-695b-7048-86fb-80aefc11b474.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.esquiretavern-sa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6822742892410802772&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-esquire-tavern",
      "poi_latitude": "29.4247353",
      "poi_longitude": "-98.4918563",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-222-2521",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-d26d-7231-a95e-1500b97cd585.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d26d-7231-a95e-1500b97cd585",
        "storage_key": "property/6767906449167664/019ffd1d-d26d-7231-a95e-1500b97cd585.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSzUPzqxYXIYRVJL3H4NAr14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_3ce1e773-2038-4dc6-84ff-6c4501311dc0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Iron Cactus Mexican Restaurant and Margarita Bar",
      "poi_type": "Restaurants",
      "poi_address": "200 River Walk Suite 100, San Antonio, TX 78205, USA",
      "poi_short_description": "Outpost of a Texas chain with traditional & modern fare, happy hour & many tequilas.",
      "poi_long_description": "Outpost of a Texas chain with traditional & modern fare, happy hour & many tequilas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-64aa-700a-b07d-25f20bfb45a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-64aa-700a-b07d-25f20bfb45a8",
        "storage_key": "property/6767906449167664/019ffd1d-64aa-700a-b07d-25f20bfb45a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ironcactus.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1030424582055903414&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "iron-cactus-mexican-restaurant-and-margarita-bar",
      "poi_latitude": "29.4250659",
      "poi_longitude": "-98.490837",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-224-9835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIWAlEKtYXIYRtsBFrbLNTA4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_088a69fd-7cb1-449c-bc2a-c2282de4758f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Brenner's on the River Walk",
      "poi_type": "Restaurants",
      "poi_address": "215 Losoya St, San Antonio, TX 78205, USA",
      "poi_short_description": "Upscale steakhouse featuring an elegant, woodsy interior & a charming garden terrace.",
      "poi_long_description": "Upscale steakhouse featuring an elegant, woodsy interior & a charming garden terrace.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-6a82-75d0-bed2-f0e73a2b62b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-6a82-75d0-bed2-f0e73a2b62b8",
        "storage_key": "property/6767906449167664/019ffd1d-6a82-75d0-bed2-f0e73a2b62b8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.brennerssteakhouse.com/location/brenners-on-the-river-walk/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3143479931858849671&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brenners-on-the-river-walk",
      "poi_latitude": "29.42457169999999",
      "poi_longitude": "-98.4880027",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 726-215-8703",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3wIgsF1ZXIYRhw8E2Vfinys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_b7e17296-6db9-4e9b-8534-f63ebfaa4e6c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Chart House",
      "poi_type": "Restaurants",
      "poi_address": "739 E César E. Chávez Blvd, San Antonio, TX 78205, USA",
      "poi_short_description": "High-end chain eatery serving seafood & steakhouse fare in a classy setting with views.",
      "poi_long_description": "High-end chain eatery serving seafood & steakhouse fare in a classy setting with views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-63e5-767e-9fc4-3099da41ea6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-63e5-767e-9fc4-3099da41ea6b",
        "storage_key": "property/6767906449167664/019ffd1d-63e5-767e-9fc4-3099da41ea6b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.chart-house.com/location/chart-house-san-antonio-tx/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15927867014991219872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chart-house",
      "poi_latitude": "29.4189966",
      "poi_longitude": "-98.4835464",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-223-3101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8VS7P_1XIYRoIw2IqkmC90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_9466ae91-0756-428e-92a0-7c17336ca55c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Dorrego's",
      "poi_type": "Restaurants",
      "poi_address": "150 E Houston St, San Antonio, TX 78205, USA",
      "poi_short_description": "Hotel Valencia Riverwalk restaurant serving locally sourced Argentinian plates paired with wines.",
      "poi_long_description": "Hotel Valencia Riverwalk restaurant serving locally sourced Argentinian plates paired with wines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-6136-7673-a20c-69158d09720a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-6136-7673-a20c-69158d09720a",
        "storage_key": "property/6767906449167664/019ffd1d-6136-7673-a20c-69158d09720a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.dorregos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6442616916497151567&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dorregos",
      "poi_latitude": "29.4263544",
      "poi_longitude": "-98.4917162",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-230-8454",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdXd9O1NfXIYRTza8e_PFaFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_ffefc2d7-e81d-4792-8518-dbb3175fd160",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "La Villita Cafe",
      "poi_type": "Restaurants",
      "poi_address": "418 Villita St, San Antonio, TX 78205, USA",
      "poi_short_description": "Local art lines the walls of this comfy cafe with local craft beer on tap & counter seats.",
      "poi_long_description": "Local art lines the walls of this comfy cafe with local craft beer on tap & counter seats.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-6ce7-7666-922c-d1bf810c7f8f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-6ce7-7666-922c-d1bf810c7f8f",
        "storage_key": "property/6767906449167664/019ffd1d-6ce7-7666-922c-d1bf810c7f8f.webp",
        "width": 1247,
        "height": 1280
      },
      "poi_business_url": "http://lavillitacafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7713026543530684626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-villita-cafe",
      "poi_latitude": "29.4214682",
      "poi_longitude": "-98.4891433",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-223-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-d21f-7135-b7fb-bc212bfaa640.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d21f-7135-b7fb-bc212bfaa640",
        "storage_key": "property/6767906449167664/019ffd1d-d21f-7135-b7fb-bc212bfaa640.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJExdrnqtYXIYR0jBOpsYsCms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_1c81d529-a439-4093-9816-17e9ef076370",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Domingo Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "123 N St Mary's St, San Antonio, TX 78205, USA",
      "poi_short_description": "Traditional fare offered in a stylish, riverside locale with a spacious terrace.",
      "poi_long_description": "Traditional fare offered in a stylish, riverside locale with a spacious terrace.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-4cdc-73eb-8ba9-47585e6c80dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-4cdc-73eb-8ba9-47585e6c80dd",
        "storage_key": "property/6767906449167664/019ffd1a-4cdc-73eb-8ba9-47585e6c80dd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.domingorestaurant.com/?SEO_id=GMB--R-SATPYPY&y_source=1_Mjg5MTMwOTktNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=9419558226313164950&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "domingo-restaurant",
      "poi_latitude": "29.42482769999999",
      "poi_longitude": "-98.4915921",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-404-7516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrTXozqxYXIYRljiBxEz-uII",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_61077713-0f80-49ef-9bdf-82a14b1942ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Biga - San Antonio Riverwalk Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "203 S St Mary's St, San Antonio, TX 78205, USA",
      "poi_short_description": "Chic River Walk eatery with adventurous New American fare, worldly wines & an ever-changing menu.",
      "poi_long_description": "Chic River Walk eatery with adventurous New American fare, worldly wines & an ever-changing menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-6ebd-723c-9d29-d312b641222b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-6ebd-723c-9d29-d312b641222b",
        "storage_key": "property/6767906449167664/019ffd1d-6ebd-723c-9d29-d312b641222b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://biga.com/?utm_source=GoogleLocal&utm_campaign=GoogleLocal",
      "poi_directions_map_url": "https://maps.google.com/?cid=16032547321510139907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "biga---san-antonio-riverwalk-restaurant",
      "poi_latitude": "29.423704",
      "poi_longitude": "-98.492007",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-225-0722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJU9YM56xYXIYRA5hAR9gMf94",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4e44a850-b931-4079-aa88-f45dda3d601b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Fig Tree Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "515 Villita St, San Antonio, TX 78205, USA",
      "poi_short_description": "Historic spot with upscale cuisine (from beef Wellington to baked Alaska), fine wines & river views.",
      "poi_long_description": "Historic spot with upscale cuisine (from beef Wellington to baked Alaska), fine wines & river views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-76af-721d-8691-243d10bbb5d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-76af-721d-8691-243d10bbb5d9",
        "storage_key": "property/6767906449167664/019ffd1d-76af-721d-8691-243d10bbb5d9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://figtreerestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16845668708472191100&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fig-tree-restaurant",
      "poi_latitude": "29.421901",
      "poi_longitude": "-98.488253",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN1fPoqtYXIYRfPhlLHDWx-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "french_restaurant"
    },
    {
      "id": "custom_1e1c10cc-c827-4537-87c8-0ef6c1c25885",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "La Margarita Mexican Restaurant & Oyster Bar",
      "poi_type": "Restaurants",
      "poi_address": "120 Produce Row, San Antonio, TX 78207, USA",
      "poi_short_description": "Lively Market Square eatery with sizzling fajitas, seafood, margaritas, mariachis & patio dining.",
      "poi_long_description": "Lively Market Square eatery with sizzling fajitas, seafood, margaritas, mariachis & patio dining.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-71fb-7408-8897-b41bdf0f6cf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-71fb-7408-8897-b41bdf0f6cf4",
        "storage_key": "property/6767906449167664/019ffd1d-71fb-7408-8897-b41bdf0f6cf4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lamargarita.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1860637334961964454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-margarita-mexican-restaurant--oyster-bar",
      "poi_latitude": "29.4249299",
      "poi_longitude": "-98.4990776",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-898-1745",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a568ebb28e87",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a568ebb28e87.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44hzy0xfXIYRpsU8TsxP0hk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_18e64f5c-de59-4686-836d-31f7bb886fdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "516 S Flores St, San Antonio, TX 78204, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-4901-725e-9e93-e27fb723399e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-4901-725e-9e93-e27fb723399e",
        "storage_key": "property/6767906449167664/019ffd1a-4901-725e-9e93-e27fb723399e.webp",
        "width": 1191,
        "height": 670
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/san-antonio/south-flores-market-h-e-b-718?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=10167437052242249511&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "29.4190775",
      "poi_longitude": "-98.4964768",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-444-1879",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79fe-733e-8be9-1b480989313c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79fe-733e-8be9-1b480989313c",
        "storage_key": "property/6767906449167664/019ffd1a-79fe-733e-8be9-1b480989313c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLdkh9bFYXIYRJ0cLLyH-GY0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e475c7eb-5a65-41f8-83c4-25a5e3a8cb73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "300 E Houston St, San Antonio, TX 78205, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-70e9-76fc-865b-fb67105e2929.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-70e9-76fc-865b-fb67105e2929",
        "storage_key": "property/6767906449167664/019ffd1d-70e9-76fc-865b-fb67105e2929.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-300+e+houston+st-san+antonio-tx-78205/id=12520",
      "poi_directions_map_url": "https://maps.google.com/?cid=12895328797626324654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "29.4261714",
      "poi_longitude": "-98.4894737",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-424-3462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQIWplRfXIYRrtZhFDhp9bI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_a976e303-012a-40d5-9ec4-410f79dcc68e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "201 W Commerce St Ste 101, San Antonio, TX 78205, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-7133-76d9-8cf1-d20e1122b57b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-7133-76d9-8cf1-d20e1122b57b",
        "storage_key": "property/6767906449167664/019ffd1d-7133-76d9-8cf1-d20e1122b57b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/tx/san-antonio/201-w-commerce-36890?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3263005817240796304&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "29.4252998",
      "poi_longitude": "-98.4948514",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-354-3291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-d1be-748d-b111-371a546f9e77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d1be-748d-b111-371a546f9e77",
        "storage_key": "property/6767906449167664/019ffd1d-d1be-748d-b111-371a546f9e77.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ-48orVJfXIYRkLyrrICGSC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_1290daac-467d-40da-8e22-eaa3910c5eef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Hemisfair",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "San Antonio, TX 78205, USA",
      "poi_short_description": "Iconic park housing Tower of the Americas, Institute of Texan Cultures, fountains & a playground.",
      "poi_long_description": "Iconic park housing Tower of the Americas, Institute of Texan Cultures, fountains & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-7146-75a1-99b7-96a5325fbd0a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-7146-75a1-99b7-96a5325fbd0a",
        "storage_key": "property/6767906449167664/019ffd1d-7146-75a1-99b7-96a5325fbd0a.webp",
        "width": 1280,
        "height": 780
      },
      "poi_business_url": "http://www.hemisfair.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2240994047339857784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hemisfair",
      "poi_latitude": "29.4201904",
      "poi_longitude": "-98.4871807",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-709-4750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a912fa9db7c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a912fa9db7c5",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a912fa9db7c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4TFB4alYXIYReAd1dzacGR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9cf38e60-de51-47c2-b571-6d5616d9f7bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "La Villita National Historic Village",
      "poi_type": "Entertainment",
      "poi_address": "418 Villita St, San Antonio, TX 78205, USA",
      "poi_short_description": "Square-block enclave of art galleries & shops, listed on the National Registry of Historic Places.",
      "poi_long_description": "Square-block enclave of art galleries & shops, listed on the National Registry of Historic Places.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-769d-7058-967b-348c7a1160c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-769d-7058-967b-348c7a1160c3",
        "storage_key": "property/6767906449167664/019ffd1d-769d-7058-967b-348c7a1160c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.lavillitasanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8845209861127091899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-villita-national-historic-village",
      "poi_latitude": "29.4217035",
      "poi_longitude": "-98.4891147",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-207-8614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a074d4ddc596.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a074d4ddc596",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a074d4ddc596.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYXjllKtYXIYRuzZDOIF_wHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_8f4d66a7-b49b-4111-8e01-8dfb0a2e7a5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Historic Market Square",
      "poi_type": "Shopping & Retail",
      "poi_address": "514 W Commerce St, San Antonio, TX 78207, USA",
      "poi_short_description": "Mexican shopping area boasting 100 shops over 3-blocks, with apparel, handcrafts & food galore.",
      "poi_long_description": "Mexican shopping area boasting 100 shops over 3-blocks, with apparel, handcrafts & food galore.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-77ca-775f-9c6d-1cc51f2dbb14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-77ca-775f-9c6d-1cc51f2dbb14",
        "storage_key": "property/6767906449167664/019ffd1d-77ca-775f-9c6d-1cc51f2dbb14.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.marketsquaresa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8417321236566237357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "historic-market-square",
      "poi_latitude": "29.4254328",
      "poi_longitude": "-98.4999185",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-207-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c15c1442e59e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c15c1442e59e",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c15c1442e59e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTQ0gykxfXIYRreDhWRFV0HQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "market"
    },
    {
      "id": "custom_63539b0d-b16f-4a84-b153-b5930be453b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Shops at Rivercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "849 E Commerce St, San Antonio, TX 78205, USA",
      "poi_short_description": "Mall on the Riverwalk featuring popular chain stores, restaurants, an IMAX movie theater & a hotel.",
      "poi_long_description": "Mall on the Riverwalk featuring popular chain stores, restaurants, an IMAX movie theater & a hotel.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-4af3-708d-bea1-b0901c3fc762.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-4af3-708d-bea1-b0901c3fc762",
        "storage_key": "property/6767906449167664/019ffd1a-4af3-708d-bea1-b0901c3fc762.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://shoprivercenter.com/?utm_source=SAC&utm_medium=GMB&utm_campaign=2026",
      "poi_directions_map_url": "https://maps.google.com/?cid=10945786990514650927&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shops-at-rivercenter",
      "poi_latitude": "29.4238596",
      "poi_longitude": "-98.4851568",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-225-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c15c1442e59e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c15c1442e59e",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c15c1442e59e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJWQFYkapYXIYRL7-3TEY_55c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_aa6e1b81-6cce-4dc3-95e5-6318b92a322d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Paris Hatters",
      "poi_type": "Shopping & Retail",
      "poi_address": "119 Broadway, San Antonio, TX 78205, USA",
      "poi_short_description": "This local fixture carries hats of all sorts, including Western styles, & offers custom fittings.",
      "poi_long_description": "This local fixture carries hats of all sorts, including Western styles, & offers custom fittings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-7c8d-762a-ac5d-01509fff4d1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-7c8d-762a-ac5d-01509fff4d1c",
        "storage_key": "property/6767906449167664/019ffd1d-7c8d-762a-ac5d-01509fff4d1c.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.parishatters.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8121779044628286573&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paris-hatters",
      "poi_latitude": "29.4272154",
      "poi_longitude": "-98.4879418",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-223-3453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c15c1442e59e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c15c1442e59e",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c15c1442e59e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJE-r561RfXIYRbcxHkwJbtnA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_a5009dfb-e1b4-4846-aeed-da0aa439fe43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Alamo Gift Shop",
      "poi_type": "Shopping & Retail",
      "poi_address": "300 Alamo Plaza, San Antonio, TX 78205, USA",
      "poi_short_description": "Gift shop at the historical site offering a variety of Alamo-themed clothes, jewelry & souvenirs.",
      "poi_long_description": "Gift shop at the historical site offering a variety of Alamo-themed clothes, jewelry & souvenirs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-7d3d-711b-9f5f-d71708f4b0d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-7d3d-711b-9f5f-d71708f4b0d6",
        "storage_key": "property/6767906449167664/019ffd1d-7d3d-711b-9f5f-d71708f4b0d6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://store.thealamo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3436919167329501572&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alamo-gift-shop",
      "poi_latitude": "29.4259493",
      "poi_longitude": "-98.4858996",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-225-1391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c15c1442e59e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c15c1442e59e",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c15c1442e59e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG91jMlVfXIYRhAFo6sVjsi8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gift_shop"
    },
    {
      "id": "custom_56291cfc-7fbe-47db-9915-b68717473b31",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Contemporary at Blue Star",
      "poi_type": "Entertainment",
      "poi_address": "116 Blue Star, San Antonio, TX 78204, USA",
      "poi_short_description": "Veteran institution showcasing local & regional contemporary artists in an airy, industrial space.",
      "poi_long_description": "Veteran institution showcasing local & regional contemporary artists in an airy, industrial space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-790f-717f-b516-5e103afb1623.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-790f-717f-b516-5e103afb1623",
        "storage_key": "property/6767906449167664/019ffd1d-790f-717f-b516-5e103afb1623.webp",
        "width": 1280,
        "height": 969
      },
      "poi_business_url": "https://contemporarysa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17662642039886085569&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "contemporary-at-blue-star",
      "poi_latitude": "29.40873259999999",
      "poi_longitude": "-98.4952521",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-227-6960",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79eb-76ea-a3af-afc34361981e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79eb-76ea-a3af-afc34361981e",
        "storage_key": "property/6767906449167664/019ffd1a-79eb-76ea-a3af-afc34361981e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJTQ84TLtYXIYRwX1KxlpPHvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_536e9dda-568b-4936-8ed1-efebc677c540",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "CAST Tech High School",
      "poi_type": "Education",
      "poi_address": "637 N Main Ave, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-7d3d-711b-9f5f-d22b8d2d2959.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-7d3d-711b-9f5f-d22b8d2d2959",
        "storage_key": "property/6767906449167664/019ffd1d-7d3d-711b-9f5f-d22b8d2d2959.webp",
        "width": 1280,
        "height": 954
      },
      "poi_business_url": "https://www.saisd.net/casttech",
      "poi_directions_map_url": "https://maps.google.com/?cid=8686934906349737651&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cast-tech-high-school",
      "poi_latitude": "29.4320878",
      "poi_longitude": "-98.4956737",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-554-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7a27-70db-97aa-ee8536ac57e2",
        "storage_key": "property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDW7u3FFfXIYRs9bqn0Uxjng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_0ffdfa24-177a-4002-aa7c-0298030721b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Healy Murphy Child Development Center",
      "poi_type": "Education",
      "poi_address": "611 Chestnut St, San Antonio, TX 78202, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.healymurphy.org/child-development-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7061264929736951415&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "healy-murphy-child-development-center",
      "poi_latitude": "29.4278296",
      "poi_longitude": "-98.4794587",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-224-9569",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7a27-70db-97aa-ee8536ac57e2",
        "storage_key": "property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy01XzL31XIYRdwblmQqn_mE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_7daef5e8-c336-448d-9874-267f57d1beb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "First Presbyterian Church",
      "poi_type": "Education",
      "poi_address": "404 N Alamo St, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-7dbd-7749-a71c-74ffd53a731d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-7dbd-7749-a71c-74ffd53a731d",
        "storage_key": "property/6767906449167664/019ffd1d-7dbd-7749-a71c-74ffd53a731d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.fpcsanantonio.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8321847067730409500&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-presbyterian-church",
      "poi_latitude": "29.4289208",
      "poi_longitude": "-98.4840048",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-226-0215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-d20e-7434-815d-33dc616b3a94.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d20e-7434-815d-33dc616b3a94",
        "storage_key": "property/6767906449167664/019ffd1d-d20e-7434-815d-33dc616b3a94.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJPT8xh1VfXIYRHHgyK9EjfXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_e8281fa2-8975-4dca-bfd1-31cfe7e04ec3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Central Library",
      "poi_type": "Education",
      "poi_address": "600 Soledad St, San Antonio, TX 78205, USA",
      "poi_short_description": "Public library offering ample study and reading spaces, plus classes, exhibits, and a parking garage.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-807b-708c-bed1-c0a076d32d45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-807b-708c-bed1-c0a076d32d45",
        "storage_key": "property/6767906449167664/019ffd1d-807b-708c-bed1-c0a076d32d45.webp",
        "width": 1008,
        "height": 572
      },
      "poi_business_url": "http://www.mysapl.org/Visit/Locations/Central-Library",
      "poi_directions_map_url": "https://maps.google.com/?cid=15961826793925350329&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "central-library",
      "poi_latitude": "29.4325521",
      "poi_longitude": "-98.4931112",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-207-2500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-d202-74e9-8953-eaa1eab81fda.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d202-74e9-8953-eaa1eab81fda",
        "storage_key": "property/6767906449167664/019ffd1d-d202-74e9-8953-eaa1eab81fda.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJDVYZnFFfXIYRuZM7UubMg90",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_46676569-2bba-4982-8cf2-57c013bef5d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "James Bonham Academy",
      "poi_type": "Education",
      "poi_address": "925 S St Mary's St, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-81aa-737a-9095-6b98d603f681.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-81aa-737a-9095-6b98d603f681",
        "storage_key": "property/6767906449167664/019ffd1d-81aa-737a-9095-6b98d603f681.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.saisd.net/bonhamacademy",
      "poi_directions_map_url": "https://maps.google.com/?cid=5007871967372719549&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "james-bonham-academy",
      "poi_latitude": "29.4138371",
      "poi_longitude": "-98.4892663",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-228-3300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7a27-70db-97aa-ee8536ac57e2",
        "storage_key": "property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ8yrBr6hYXIYRvTXjfwWJf0U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_78e394a0-4927-4862-b74b-bd7f1de86e33",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "KIPP Aspire Academy",
      "poi_type": "Education",
      "poi_address": "239 Stark St, San Antonio, TX 78204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-84aa-77f1-ad80-bac8eca3a874.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-84aa-77f1-ad80-bac8eca3a874",
        "storage_key": "property/6767906449167664/019ffd1d-84aa-77f1-ad80-bac8eca3a874.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://kipptexas.org/school/kipp-aspire-academy/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15836515808569009797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kipp-aspire-academy",
      "poi_latitude": "29.40817",
      "poi_longitude": "-98.5062926",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-735-7300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7a27-70db-97aa-ee8536ac57e2",
        "storage_key": "property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJAy64hhZfXIYRhSad8Tibxts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e4ce2de2-2861-42f2-a865-ee339b13666e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Collins Garden Elementary",
      "poi_type": "Education",
      "poi_address": "167 Harriman Pl, San Antonio, TX 78204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-82c4-767e-bb11-6d39d50028a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-82c4-767e-bb11-6d39d50028a6",
        "storage_key": "property/6767906449167664/019ffd1d-82c4-767e-bb11-6d39d50028a6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.saisd.net/collinsgardenes",
      "poi_directions_map_url": "https://maps.google.com/?cid=10833229244148935028&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "collins-garden-elementary",
      "poi_latitude": "29.3971003",
      "poi_longitude": "-98.5178638",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 210-228-3310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7a27-70db-97aa-ee8536ac57e2",
        "storage_key": "property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJQdJLeZYXIYRdOnew5lcV5Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_f9dbe352-b20a-4c27-a4eb-a6e2a139eccd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "San Antonio College",
      "poi_type": "Education",
      "poi_address": "1819 N Main Ave, San Antonio, TX 78212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-519e-76c5-8aba-fc91006033e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-519e-76c5-8aba-fc91006033e4",
        "storage_key": "property/6767906449167664/019ffd1a-519e-76c5-8aba-fc91006033e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alamo.edu/sac/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12153728245465743446&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-college",
      "poi_latitude": "29.4457849",
      "poi_longitude": "-98.4959969",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 210-486-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7a27-70db-97aa-ee8536ac57e2",
        "storage_key": "property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQ1nBxEJfXIYRVgCeL3K3qqg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_fb198a21-a986-47b0-871a-da5aa6cb4b6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Trinity University",
      "poi_type": "Education",
      "poi_address": "1 Trinity Pl, San Antonio, TX 78212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-52c0-745e-b1ac-61dcf53ad8fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-52c0-745e-b1ac-61dcf53ad8fe",
        "storage_key": "property/6767906449167664/019ffd1a-52c0-745e-b1ac-61dcf53ad8fe.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://www.trinity.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1542864360290490523&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trinity-university",
      "poi_latitude": "29.4618769",
      "poi_longitude": "-98.4833382",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-999-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7a27-70db-97aa-ee8536ac57e2",
        "storage_key": "property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxbr4W5lhXIYRm5i5E_ZaaRU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7fc3120a-bf58-4a43-b856-9a03b8dbef59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Our Lady of the Lake University",
      "poi_type": "Education",
      "poi_address": "411 SW 24th St, San Antonio, TX 78207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-844c-71ae-8c8a-24cfb940fcc3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-844c-71ae-8c8a-24cfb940fcc3",
        "storage_key": "property/6767906449167664/019ffd1d-844c-71ae-8c8a-24cfb940fcc3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.ollusa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13253284947980199112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "our-lady-of-the-lake-university",
      "poi_latitude": "29.4262763",
      "poi_longitude": "-98.5434121",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 210-434-6711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7a27-70db-97aa-ee8536ac57e2",
        "storage_key": "property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJxVszOcxeXIYRyCRk93Ag7bc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_89cb78fc-cb3e-4f4a-ba24-6a8e9ce325ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Tobin Center for the Performing Arts",
      "poi_type": "Entertainment",
      "poi_address": "100 Auditorium Cir, San Antonio, TX 78205, USA",
      "poi_short_description": "Large venue hosting Broadway tours and concerts of many genres, plus ballet and other live events.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-83ea-704d-8e2a-7a08ee1fdf66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-83ea-704d-8e2a-7a08ee1fdf66",
        "storage_key": "property/6767906449167664/019ffd1d-83ea-704d-8e2a-7a08ee1fdf66.webp",
        "width": 930,
        "height": 523
      },
      "poi_business_url": "https://www.tobincenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12854864989977135831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tobin-center-for-the-performing-arts",
      "poi_latitude": "29.4306593",
      "poi_longitude": "-98.4887048",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-223-8624",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfVwRGlRfXIYR10oxs5mnZbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_ade3e605-ebab-4b33-8677-f8489d2a5bd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Yanaguana Garden at Hemisfair",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "434 S Alamo St, San Antonio, TX 78205, USA",
      "poi_short_description": "Modern park with innovative climbing structures & swings, a giant chessboard & colorful artworks.",
      "poi_long_description": "Modern park with innovative climbing structures & swings, a giant chessboard & colorful artworks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-86a3-7530-a479-9a8f84a8b479.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-86a3-7530-a479-9a8f84a8b479",
        "storage_key": "property/6767906449167664/019ffd1d-86a3-7530-a479-9a8f84a8b479.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://hemisfair.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17715800802505384848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yanaguana-garden-at-hemisfair",
      "poi_latitude": "29.4195662",
      "poi_longitude": "-98.4878609",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "3 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-709-4750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a912fa9db7c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a912fa9db7c5",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a912fa9db7c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK-t_YalYXIYRkOPpsPcq2_U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_977f6942-7861-4939-bd94-b7da76781d26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "The Alamo",
      "poi_type": "Entertainment",
      "poi_address": "300 Alamo Plaza, San Antonio, TX 78205, USA",
      "poi_short_description": "Small, shrinelike fortress & monument to Texas history with a museum, artifacts, gardens & more.",
      "poi_long_description": "Small, shrinelike fortress & monument to Texas history with a museum, artifacts, gardens & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-890a-71ec-b91c-860d9bf9c178.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-890a-71ec-b91c-860d9bf9c178",
        "storage_key": "property/6767906449167664/019ffd1d-890a-71ec-b91c-860d9bf9c178.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.thealamo.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1727569228890358818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-alamo",
      "poi_latitude": "29.4259671",
      "poi_longitude": "-98.4861419",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-225-1391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a074d4ddc596.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a074d4ddc596",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a074d4ddc596.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4k2TVVfXIYRIsTnhA-P-Rc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    },
    {
      "id": "custom_a9178258-0a4e-4dd3-ae4a-e41336c8d617",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Majestic Theatre",
      "poi_type": "Entertainment",
      "poi_address": "224 E Houston St, San Antonio, TX 78205, USA",
      "poi_short_description": "This ornate Mediterranean-style landmark built in 1929 features touring concerts & Broadway shows.",
      "poi_long_description": "This ornate Mediterranean-style landmark built in 1929 features touring concerts & Broadway shows.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-86bd-7618-83ae-cf411a1d0bc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-86bd-7618-83ae-cf411a1d0bc0",
        "storage_key": "property/6767906449167664/019ffd1d-86bd-7618-83ae-cf411a1d0bc0.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://us.atgtickets.com/venues/majestic-theatre/whats-on/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5135301984976611197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "majestic-theatre",
      "poi_latitude": "29.4261726",
      "poi_longitude": "-98.4906058",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 888-811-5040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfZxkRFNfXIYRfafjhPJBREc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_658d6e0b-8c6e-44b7-a317-cbe3f345bb9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Aztec Theatre",
      "poi_type": "Entertainment",
      "poi_address": "104 N St Mary's St, San Antonio, TX 78205, USA",
      "poi_short_description": "Ornate concert venue that also stages plays, films and weddings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-8b62-729d-abf9-8a8e4928b36e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-8b62-729d-abf9-8a8e4928b36e",
        "storage_key": "property/6767906449167664/019ffd1d-8b62-729d-abf9-8a8e4928b36e.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.theaztectheatre.com/?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=7852487536378228343&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aztec-theatre",
      "poi_latitude": "29.4247856",
      "poi_longitude": "-98.4910964",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-812-4355",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXYrXrP1ZXIYRd64BYc-j-Ww",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_e4f4b784-c68f-4f8d-8c6c-fcfb21c4934e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "San Antonio Museum of Art",
      "poi_type": "Entertainment",
      "poi_address": "200 W Jones Ave, San Antonio, TX 78215, USA",
      "poi_short_description": "Egyptian, Greek, Roman, Latin American & contemporary collections in the former Lone Star Brewery.",
      "poi_long_description": "Egyptian, Greek, Roman, Latin American & contemporary collections in the former Lone Star Brewery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-8dab-76cd-9902-9d978d81eb19.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-8dab-76cd-9902-9d978d81eb19",
        "storage_key": "property/6767906449167664/019ffd1d-8dab-76cd-9902-9d978d81eb19.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.samuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8027482300510423073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-museum-of-art",
      "poi_latitude": "29.4372761",
      "poi_longitude": "-98.4821898",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-978-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79eb-76ea-a3af-afc34361981e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79eb-76ea-a3af-afc34361981e",
        "storage_key": "property/6767906449167664/019ffd1a-79eb-76ea-a3af-afc34361981e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJGR8ZJvj1XIYRIcio8p5YZ28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_022ab132-9f40-4dc8-85ed-a07cf937e28f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Briscoe Western Art Museum",
      "poi_type": "Entertainment",
      "poi_address": "210 W Market St, San Antonio, TX 78205, USA",
      "poi_short_description": "Modern museum housing art & artifacts reflecting the history & culture of the American West.",
      "poi_long_description": "Modern museum housing art & artifacts reflecting the history & culture of the American West.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-8dac-7527-bbae-abd941128995.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-8dac-7527-bbae-abd941128995",
        "storage_key": "property/6767906449167664/019ffd1d-8dac-7527-bbae-abd941128995.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.briscoemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9049069619822621695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "briscoe-western-art-museum",
      "poi_latitude": "29.4229603",
      "poi_longitude": "-98.4891439",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-299-4499",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79eb-76ea-a3af-afc34361981e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79eb-76ea-a3af-afc34361981e",
        "storage_key": "property/6767906449167664/019ffd1a-79eb-76ea-a3af-afc34361981e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJP8iNQatYXIYR_3NODeDAlH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_6b296cb8-8b09-41eb-a4c8-19d61cb966f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "LEGOLAND Discovery Center San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "849 E Commerce St Ste 910, San Antonio, TX 78205, USA",
      "poi_short_description": "Family entertainment center featuring a 4D theater, LEGO toy displays, rides, and play zones.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-9130-71c5-93b8-95357dee29bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-9130-71c5-93b8-95357dee29bf",
        "storage_key": "property/6767906449167664/019ffd1d-9130-71c5-93b8-95357dee29bf.webp",
        "width": 1023,
        "height": 682
      },
      "poi_business_url": "https://www.legolanddiscoverycenter.com/san-antonio/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=8962097653253065827&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "legoland-discovery-center-san-antonio",
      "poi_latitude": "29.42398349999999",
      "poi_longitude": "-98.4846229",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-610-1150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGyvt8DRZXIYRY8yCGFXEX3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_ddcff214-7256-48ff-ba71-c134c6e3874e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "SEA LIFE San Antonio",
      "poi_type": "Entertainment",
      "poi_address": "849 E Commerce St Ste 600, San Antonio, TX 78205, USA",
      "poi_short_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_long_description": "Family-friendly exhibits with a variety of sea creatures (most offer play areas & group packages).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-9bc0-778e-b438-f2fba2a3147f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-9bc0-778e-b438-f2fba2a3147f",
        "storage_key": "property/6767906449167664/019ffd1d-9bc0-778e-b438-f2fba2a3147f.webp",
        "width": 1280,
        "height": 1050
      },
      "poi_business_url": "https://www.visitsealife.com/san-antonio/?utm_source=local-listing&utm_medium=organic&utm_campaign=tickets",
      "poi_directions_map_url": "https://maps.google.com/?cid=17081593324529397368&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sea-life-san-antonio",
      "poi_latitude": "29.424208",
      "poi_longitude": "-98.486231",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-610-1160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-d20e-7434-815d-2fffb99d1bdd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d20e-7434-815d-2fffb99d1bdd",
        "storage_key": "property/6767906449167664/019ffd1d-d20e-7434-815d-2fffb99d1bdd.webp",
        "width": 192,
        "height": 176
      },
      "poi_google_place_id": "ChIJUUTPVKJZXIYReC5CYqACDu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_71efaf06-0334-47de-b780-5c686e6618dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Arneson River Theatre",
      "poi_type": "Entertainment",
      "poi_address": "418 Villita St, San Antonio, TX 78205, USA",
      "poi_short_description": "Built in 1939, this open-air stage hosts riverfront performances from dance to music and opera.",
      "poi_long_description": "Built in 1939, this open-air stage hosts riverfront performances from dance to music and opera.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-9b64-74fa-9010-0bc933dba8ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-9b64-74fa-9010-0bc933dba8ab",
        "storage_key": "property/6767906449167664/019ffd1d-9b64-74fa-9010-0bc933dba8ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.getcreativesanantonio.com/Explore-San-Antonio/La-Villita",
      "poi_directions_map_url": "https://maps.google.com/?cid=1695784380978684102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arneson-river-theatre",
      "poi_latitude": "29.42210069999999",
      "poi_longitude": "-98.4887824",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 210-207-8614",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJMTTbw6tYXIYRxuDj6-iiiBc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_33d124fb-e6c9-47cd-8cdc-d70c1f9b9b9e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Baptist Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "111 Dallas St, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-64b3-720b-b412-546506d88f21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-64b3-720b-b412-546506d88f21",
        "storage_key": "property/6767906449167664/019ffd1a-64b3-720b-b412-546506d88f21.webp",
        "width": 961,
        "height": 1280
      },
      "poi_business_url": "https://www.baptisthealthsystem.com/location/detail/baptist-medical-center/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-baptist-medical-center&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3396036108956313548&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-medical-center",
      "poi_latitude": "29.4334891",
      "poi_longitude": "-98.4923606",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-297-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79ea-7358-aff2-adb5e42a8431.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79ea-7358-aff2-adb5e42a8431",
        "storage_key": "property/6767906449167664/019ffd1a-79ea-7358-aff2-adb5e42a8431.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN5VRVlBfXIYRzKe9HtkkIS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_d9ad0efe-e5ac-4a47-8e41-2358d113f072",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "CHRISTUS Children's",
      "poi_type": "Health and Wellness",
      "poi_address": "333 N Santa Rosa St, San Antonio, TX 78207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-a2c8-7029-a654-4cfefe685036.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-a2c8-7029-a654-4cfefe685036",
        "storage_key": "property/6767906449167664/019ffd1d-a2c8-7029-a654-4cfefe685036.webp",
        "width": 1280,
        "height": 989
      },
      "poi_business_url": "https://www.christushealth.org/locations/childrens-hospital?utm_source=GBP&utm_medium=organic&utm_campaign=GBP-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=12991254685047924425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christus-childrens",
      "poi_latitude": "29.4269652",
      "poi_longitude": "-98.498613",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-704-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79ea-7358-aff2-adb5e42a8431.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79ea-7358-aff2-adb5e42a8431",
        "storage_key": "property/6767906449167664/019ffd1a-79ea-7358-aff2-adb5e42a8431.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJF8VlUExfXIYRySbpME41SrQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f9b529e5-1a30-4d3d-b0e3-2f6602637ddf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Concentra Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "710 Augusta St, San Antonio, TX 78215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-9ced-7059-bfe1-95c997cbb59f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-9ced-7059-bfe1-95c997cbb59f",
        "storage_key": "property/6767906449167664/019ffd1d-9ced-7059-bfe1-95c997cbb59f.webp",
        "width": 728,
        "height": 351
      },
      "poi_business_url": "http://www.concentra.com/?utm_source=Yext&utm_medium=Referral&utm_campaign=Homepage%20Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=4654919383194910435&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "concentra-urgent-care",
      "poi_latitude": "29.433812",
      "poi_longitude": "-98.488372",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 210-298-9888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBeKN4FZfXIYR475pJYSYmUA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_07c3fe12-4107-4568-bfab-37572db3b026",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "300 E Commerce St, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-9e16-705b-aba2-35bca76ae4ee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-9e16-705b-aba2-35bca76ae4ee",
        "storage_key": "property/6767906449167664/019ffd1d-9e16-705b-aba2-35bca76ae4ee.webp",
        "width": 1000,
        "height": 667
      },
      "poi_business_url": "https://www.cvs.com/store-locator/san-antonio-tx-pharmacies/300-east-commerce-st-san-antonio-tx-78205/storeid=10179?WT.mc_id=LS_GOOGLE_RX_10179",
      "poi_directions_map_url": "https://maps.google.com/?cid=17999400519053741740&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.423899",
      "poi_longitude": "-98.4897559",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-228-9483",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-d20c-7164-b4b2-24fd78df6c36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d20c-7164-b4b2-24fd78df6c36",
        "storage_key": "property/6767906449167664/019ffd1d-d20c-7164-b4b2-24fd78df6c36.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD5X8n6xYXIYRrA4uPGi3yvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_223e7e7d-11dd-4295-a5a1-7609cfb7e84b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "300 E Houston St, San Antonio, TX 78205, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-a781-71d1-9903-c0e79e0b3ad3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-a781-71d1-9903-c0e79e0b3ad3",
        "storage_key": "property/6767906449167664/019ffd1d-a781-71d1-9903-c0e79e0b3ad3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-300+e+houston+st-san+antonio-tx-78205/id=12520",
      "poi_directions_map_url": "https://maps.google.com/?cid=8850082494903642219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "29.4261548",
      "poi_longitude": "-98.4894691",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-424-3462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-d20c-7164-b4b2-24fd78df6c36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1d-d20c-7164-b4b2-24fd78df6c36",
        "storage_key": "property/6767906449167664/019ffd1d-d20c-7164-b4b2-24fd78df6c36.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaQIWplRfXIYRa2iirSPP0Xo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_4f5d1d45-109e-44ad-8b22-168f61279d9a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "EnergyX Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "623 Hemisfair Blvd, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-a2c8-7029-a654-50a402759f4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-a2c8-7029-a654-50a402759f4b",
        "storage_key": "property/6767906449167664/019ffd1d-a2c8-7029-a654-50a402759f4b.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://www.energyxfitness.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3865967756650708418&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "energyx-fitness",
      "poi_latitude": "29.4190279",
      "poi_longitude": "-98.486828",
      "poi_miles_from_property": "0.01",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 210-608-4241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4WYonalYXIYRwn1HIDGtpjU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_56b03410-60f0-4205-b8c8-ef1db61c1d3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "War House Gym San Antonio",
      "poi_type": "Health and Wellness",
      "poi_address": "119 W Lachapelle, San Antonio, TX 78204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-5b50-7330-a40a-53bbc23d9aa7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-5b50-7330-a40a-53bbc23d9aa7",
        "storage_key": "property/6767906449167664/019ffd1a-5b50-7330-a40a-53bbc23d9aa7.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "https://engineering-an-empire.getlearnworlds.com/home?site_template_id=63b7658f39799e5e7508fb01",
      "poi_directions_map_url": "https://maps.google.com/?cid=3137458253073811561&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "war-house-gym-san-antonio",
      "poi_latitude": "29.4064417",
      "poi_longitude": "-98.5034132",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-636-9655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ2bGeCtZXIYRaQgVgKh9iis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_c2bc9d7d-d7f7-4baa-99f6-eed9c6b2b6a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Black Swan Yoga San Antonio - Downtown",
      "poi_type": "Health and Wellness",
      "poi_address": "914 E Elmira St #201, San Antonio, TX 78212, USA",
      "poi_short_description": "Yoga chain offering classes for all levels in a clean studio with a spacious parking lot.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-5ffb-711c-88db-f5452f3f3dd4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-5ffb-711c-88db-f5452f3f3dd4",
        "storage_key": "property/6767906449167664/019ffd1a-5ffb-711c-88db-f5452f3f3dd4.webp",
        "width": 1109,
        "height": 1280
      },
      "poi_business_url": "https://blackswanyoga.com/san-antonio/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14460014588349023427&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black-swan-yoga-san-antonio---downtown",
      "poi_latitude": "29.4409238",
      "poi_longitude": "-98.4852478",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-570-6555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7a27-70db-97aa-ee8536ac57e2",
        "storage_key": "property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoe1CQDFfXIYRw4SC2adKrMg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_48a7118d-e445-4437-b777-50bbf92abecd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Tower of the Americas",
      "poi_type": "Entertainment",
      "poi_address": "739 E César E. Chávez Blvd, San Antonio, TX 78205, USA",
      "poi_short_description": "750-ft. landmark with an observation deck, revolving eatery, stationary bar & a 4D adventure ride.",
      "poi_long_description": "750-ft. landmark with an observation deck, revolving eatery, stationary bar & a 4D adventure ride.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-a32a-74fa-9dac-7a30114ee559.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-a32a-74fa-9dac-7a30114ee559",
        "storage_key": "property/6767906449167664/019ffd1d-a32a-74fa-9dac-7a30114ee559.webp",
        "width": 879,
        "height": 1280
      },
      "poi_business_url": "https://www.toweroftheamericas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14663203299292189839&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tower-of-the-americas",
      "poi_latitude": "29.4189838",
      "poi_longitude": "-98.483512",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-223-3101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPeKa9qlYXIYRj5SlM7Ypfss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_6d4015aa-3827-4c02-a0c8-9be2fd763ff2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Travis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "301 E Travis St, San Antonio, TX 78205, USA",
      "poi_short_description": "Landscaped downtown square & events hub since 1870 on 2.6 acres with picnic & café style tables.",
      "poi_long_description": "Landscaped downtown square & events hub since 1870 on 2.6 acres with picnic & café style tables.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-ab0c-734f-b83e-577ee27af1e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-ab0c-734f-b83e-577ee27af1e0",
        "storage_key": "property/6767906449167664/019ffd1d-ab0c-734f-b83e-577ee27af1e0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.travisparksa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15072962023198485603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "travis-park",
      "poi_latitude": "29.4281035",
      "poi_longitude": "-98.4891409",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-207-3677",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a912fa9db7c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a912fa9db7c5",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a912fa9db7c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbBOhlRfXIYRY-yyoRnrLdE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_65c3aec9-2d1f-452b-beb8-1308a25fe8af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "San Pedro Creek Culture Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "715 Camaron St, San Antonio, TX 78204, USA",
      "poi_short_description": "Creekside park in downtown San Antonio featuring artistic works and a walkable path.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-a7db-75aa-9926-130afc699553.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-a7db-75aa-9926-130afc699553",
        "storage_key": "property/6767906449167664/019ffd1d-a7db-75aa-9926-130afc699553.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://spcculturepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2461705146466728170&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-pedro-creek-culture-park",
      "poi_latitude": "29.4314376",
      "poi_longitude": "-98.4979518",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-227-1373",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79f5-7369-948a-a912fa9db7c5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79f5-7369-948a-a912fa9db7c5",
        "storage_key": "property/6767906449167664/019ffd1a-79f5-7369-948a-a912fa9db7c5.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR5WCf05fXIYR6njmvMm7KSI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_354ddf54-d3dd-44ef-ba4b-625e3d11ec89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "The Paseo del Rio Association",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "110 Broadway #500, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-acff-7293-812c-e268f8c8e135.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-acff-7293-812c-e268f8c8e135",
        "storage_key": "property/6767906449167664/019ffd1d-acff-7293-812c-e268f8c8e135.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.thesanantonioriverwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7718426226437252899&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-paseo-del-rio-association",
      "poi_latitude": "29.4267877",
      "poi_longitude": "-98.4876821",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-227-4262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Y1_CKtYXIYRI-fZS8JbHWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_bccc8139-2673-4009-baab-7befdb0327cc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "San Antonio BCycle",
      "poi_type": "Transportation & Transit",
      "poi_address": "510 S Alamo St, San Antonio, TX 78206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-b017-7505-b51c-a9b88fa70c0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b017-7505-b51c-a9b88fa70c0b",
        "storage_key": "property/6767906449167664/019ffd1d-b017-7505-b51c-a9b88fa70c0b.webp",
        "width": 1280,
        "height": 577
      },
      "poi_business_url": "https://sanantonio.bcycle.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4273089436357239581&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-bcycle",
      "poi_latitude": "29.419192",
      "poi_longitude": "-98.4880297",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 210-281-0101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSzOe8KlYXIYRHSOM2zMQTTs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_35a34954-dfd5-4d15-8765-d0af2263bdfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "San Antonio Amtrak Station (SAS)",
      "poi_type": "Transportation & Transit",
      "poi_address": "350 Hoefgen Ave, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-b006-75c8-bdb0-8655c8deed03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b006-75c8-bdb0-8655c8deed03",
        "storage_key": "property/6767906449167664/019ffd1d-b006-75c8-bdb0-8655c8deed03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/stations/sas",
      "poi_directions_map_url": "https://maps.google.com/?cid=17315811974640798917&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-amtrak-station-sas",
      "poi_latitude": "29.4193893",
      "poi_longitude": "-98.4780423",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 210-367-9465",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUTDm0Sv3XIYRxYzrcT8fTvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_depot"
    },
    {
      "id": "custom_3eb5886d-0226-4e00-a9a8-90e44b6217cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Greyhound Shop",
      "poi_type": "Transportation & Transit",
      "poi_address": "500 N St Mary's St, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-b20b-746c-ad49-0cbc8a8a56ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b20b-746c-ad49-0cbc8a8a56ae",
        "storage_key": "property/6767906449167664/019ffd1d-b20b-746c-ad49-0cbc8a8a56ae.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/san-antonio-tx/san-antonio-bus-station",
      "poi_directions_map_url": "https://maps.google.com/?cid=2193265979862775306&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-shop",
      "poi_latitude": "29.4289054",
      "poi_longitude": "-98.4911807",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi7PjnzWWXIYRCnary8kLcB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_51600f97-8c58-4db5-be55-4d0253c8b672",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Henry B. González Convention Center",
      "poi_type": "Entertainment",
      "poi_address": "900 E Market St, San Antonio, TX 78205, USA",
      "poi_short_description": "Spacious downtown spot for basketball-themed conventions, plus professional events and conferences.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-b714-70ce-96e0-d83cde7c821b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b714-70ce-96e0-d83cde7c821b",
        "storage_key": "property/6767906449167664/019ffd1d-b714-70ce-96e0-d83cde7c821b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sahbgcc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11158774918249612784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "henry-b-gonzlez-convention-center",
      "poi_latitude": "29.4204074",
      "poi_longitude": "-98.4836727",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-207-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJzxIBqpYXIYR8IXOmqru25o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convention_center"
    },
    {
      "id": "custom_d0dd8906-85cc-4ff3-a24b-d130c9a00a6f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "The Espee",
      "poi_type": "Entertainment",
      "poi_address": "1174 E Commerce St, San Antonio, TX 78205, USA",
      "poi_short_description": "Bands, concerts and other events play at this train depot-turned-venue showcasing weddings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-b1ab-75da-b35a-197e941358aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b1ab-75da-b35a-197e941358aa",
        "storage_key": "property/6767906449167664/019ffd1d-b1ab-75da-b35a-197e941358aa.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://us.atgtickets.com/venues/the-espee/whats-on/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11972298940440305823&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-espee",
      "poi_latitude": "29.4203836",
      "poi_longitude": "-98.4782017",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 888-811-5040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUc5jugb2XIYRn-C6UXQmJqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_9e0731be-eac4-4b97-b44d-b556dbafbd98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Alamodome",
      "poi_type": "Entertainment",
      "poi_address": "100 Montana St Ste 310 Lot A, San Antonio, TX 78203, USA",
      "poi_short_description": "Domed arena with sports, conventions, trade shows, concerts, the Illusions Theater & the Alamo Bowl.",
      "poi_long_description": "Domed arena with sports, conventions, trade shows, concerts, the Illusions Theater & the Alamo Bowl.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-54d2-76d9-9581-de75b1a78e71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-54d2-76d9-9581-de75b1a78e71",
        "storage_key": "property/6767906449167664/019ffd1a-54d2-76d9-9581-de75b1a78e71.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.alamodome.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18017975409024747272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alamodome",
      "poi_latitude": "29.4169834",
      "poi_longitude": "-98.4788143",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 210-207-3663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7a34-71fd-a240-96f6701d7b00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7a34-71fd-a240-96f6701d7b00",
        "storage_key": "property/6767906449167664/019ffd1a-7a34-71fd-a240-96f6701d7b00.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl9CdqqtYXIYRCMek0iu1DPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_cdcd3119-0865-4b5b-8245-75579c986d70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "San Antonio International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "9800 Airport Blvd, San Antonio, TX 78216, USA",
      "poi_short_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_long_description": "Airport offering international flights plus eateries & car-rental options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-b5ed-71cb-b897-728885e942bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-b5ed-71cb-b897-728885e942bd",
        "storage_key": "property/6767906449167664/019ffd1d-b5ed-71cb-b897-728885e942bd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.flysanantonio.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18041828760938859602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-international-airport",
      "poi_latitude": "29.5307982",
      "poi_longitude": "-98.4711194",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 26 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 210-207-3433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7c68-7207-ad21-a812e4d843ea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7c68-7207-ad21-a812e4d843ea",
        "storage_key": "property/6767906449167664/019ffd1a-7c68-7207-ad21-a812e4d843ea.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ4DLsbuKXIYRUswvGqtzYfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_7d57e1e8-d1f8-491d-a692-352cda71bee0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "San Antonio City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Military Plaza #4, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7281-7275-a2f9-4d13a8bbba6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7281-7275-a2f9-4d13a8bbba6a",
        "storage_key": "property/6767906449167664/019ffd1a-7281-7275-a2f9-4d13a8bbba6a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sanantonio.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8903974517540474478&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-antonio-city-hall",
      "poi_latitude": "29.4245868",
      "poi_longitude": "-98.4951446",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 210-207-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7c73-72c5-a36b-5f48e5097580.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7c73-72c5-a36b-5f48e5097580",
        "storage_key": "property/6767906449167664/019ffd1a-7c73-72c5-a36b-5f48e5097580.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUSdxOw5DXIYRbk4h_6VFkXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_3e89ac64-8770-4e93-8ad6-3165c96c1fbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Courthouse",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Bexar County Courthouse, 100 Dolorosa St B10.2, San Antonio, TX 78205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-ba40-750e-93a3-380965317d91.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-ba40-750e-93a3-380965317d91",
        "storage_key": "property/6767906449167664/019ffd1d-ba40-750e-93a3-380965317d91.webp",
        "width": 1280,
        "height": 1053
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237580673085542371&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "courthouse",
      "poi_latitude": "29.423782",
      "poi_longitude": "-98.4935257",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7c73-72c5-a36b-5f48e5097580.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7c73-72c5-a36b-5f48e5097580",
        "storage_key": "property/6767906449167664/019ffd1a-7c73-72c5-a36b-5f48e5097580.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNx-aE61YXIYR4w9_nEYNcWQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_23883652-7009-4e20-b7cc-f721c4ee062a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "H-E-B Corporate Office Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "646 S Flores St, San Antonio, TX 78204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-6a87-720e-abab-d6ed018f9861.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-6a87-720e-abab-d6ed018f9861",
        "storage_key": "property/6767906449167664/019ffd1a-6a87-720e-abab-d6ed018f9861.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/static-page/heb-corporate-office-hq",
      "poi_directions_map_url": "https://maps.google.com/?cid=10485037645668446608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-corporate-office-headquarters",
      "poi_latitude": "29.417145",
      "poi_longitude": "-98.4954154",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 210-938-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHfrImLFYXIYRkHGqxi9WgpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fb8f2dc1-928c-4156-86db-39ed43e28887",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "UTSA San Pedro I",
      "poi_type": "Education",
      "poi_address": "506 Dolorosa St Ste 102, San Antonio, TX 78204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-bfc7-74c4-8253-f7e390d770da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-bfc7-74c4-8253-f7e390d770da",
        "storage_key": "property/6767906449167664/019ffd1d-bfc7-74c4-8253-f7e390d770da.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://utsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6070072304702938390&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utsa-san-pedro-i",
      "poi_latitude": "29.4239393",
      "poi_longitude": "-98.495977",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 210-458-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-7a27-70db-97aa-ee8536ac57e2",
        "storage_key": "property/6767906449167664/019ffd1a-7a27-70db-97aa-ee8536ac57e2.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZ5ztQv5ZXIYRFl3Bupk6PVQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_07d1ae15-428a-40b9-92e7-2a83507c1a48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Valero",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Valero Way, San Antonio, TX 78249, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-c5fb-74fd-a99c-ad3c619fa500.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-c5fb-74fd-a99c-ad3c619fa500",
        "storage_key": "property/6767906449167664/019ffd1d-c5fb-74fd-a99c-ad3c619fa500.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.valero.com/ourbusiness/ourlocations/offices/pages/valerocorporateheadquarters.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=16201185604516536043&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valero",
      "poi_latitude": "29.5869869",
      "poi_longitude": "-98.6070957",
      "poi_miles_from_property": "15.3",
      "poi_walking_minutes": "5 hours 50 mins",
      "poi_biking_minutes": "2 hours 2 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 210-345-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv1eqHI5mXIYR615hQXgs1uA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_30dc98da-6019-470f-95aa-3c75aaec3954",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "USAA Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9800 Fredericksburg Rd, San Antonio, TX 78288, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-c274-759b-9142-9d16d8b0c659.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-c274-759b-9142-9d16d8b0c659",
        "storage_key": "property/6767906449167664/019ffd1d-c274-759b-9142-9d16d8b0c659.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.usaa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341051404387659836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "usaa-corporate-office",
      "poi_latitude": "29.5371902",
      "poi_longitude": "-98.5752478",
      "poi_miles_from_property": "10.4",
      "poi_walking_minutes": "4 hours 3 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-531-8722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyyb6ITJnXIYRPLBolFun4GU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_4ec033c8-0516-42f9-83c5-182d95bca6fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Southwest Research Institute",
      "poi_type": "Education",
      "poi_address": "6220 Culebra Rd, San Antonio, TX 78238, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1d-bef8-74cd-945b-f1ac7057ada8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1d-bef8-74cd-945b-f1ac7057ada8",
        "storage_key": "property/6767906449167664/019ffd1d-bef8-74cd-945b-f1ac7057ada8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.swri.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=181758218444497686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "southwest-research-institute",
      "poi_latitude": "29.4521256",
      "poi_longitude": "-98.6102811",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 210-684-5111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79e9-76ca-8b8c-c49e5bfd459b",
        "storage_key": "property/6767906449167664/019ffd1a-79e9-76ca-8b8c-c49e5bfd459b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_8dKB1pcXIYRFmNk_SK8hQI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_9991a7e4-c27a-4782-af5e-170cff220c7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Brooke Army Medical Center (BAMC)",
      "poi_type": "Health and Wellness",
      "poi_address": "3551 Roger Brooke Dr, Fort Sam Houston, TX 78234, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-646f-747d-af6c-7a2564f3f325.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ffd1a-646f-747d-af6c-7a2564f3f325",
        "storage_key": "property/6767906449167664/019ffd1a-646f-747d-af6c-7a2564f3f325.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://bamc.tricare.mil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5581840337299951468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brooke-army-medical-center-bamc",
      "poi_latitude": "29.460187",
      "poi_longitude": "-98.4162656",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 25 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 210-916-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/019ffd1a-79ea-7358-aff2-adb5e42a8431.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ffd1a-79ea-7358-aff2-adb5e42a8431",
        "storage_key": "property/6767906449167664/019ffd1a-79ea-7358-aff2-adb5e42a8431.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJN8nfo2n0XIYRbM-1gTaudk0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_582cc950-f10d-406f-8d89-e7325ae027a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "poi_name": "Plaza San Antonio Hotel & Spa, Autograph Collection",
      "poi_type": "Health and Wellness",
      "poi_address": "555 S Alamo St, San Antonio, TX 78205, USA",
      "poi_short_description": "Charming chain hotel featuring a spa, an outdoor pool, and clean rooms with comfortable beds.",
      "poi_long_description": "People say this hotel offers comfortable, clean, and spacious rooms, along with a beautiful pool area and well-maintained grounds. They also highlight the delicious food and drinks available at the on-site restaurants and bars. Guests consistently praise the friendly, welcoming, and helpful staff, especially the front desk and valet teams.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a116e3-4935-7609-96a7-2196b1caaaf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a116e3-4935-7609-96a7-2196b1caaaf2",
        "storage_key": "property/6767906449167664/01a116e3-4935-7609-96a7-2196b1caaaf2.webp",
        "width": 480,
        "height": 320
      },
      "poi_business_url": "https://www.marriott.com/en-us/hotels/satkd-plaza-san-antonio-hotel-and-spa-autograph-collection/overview/?scid=f2ae0541-1279-4f24-b197-a979c79310b0",
      "poi_directions_map_url": "https://maps.google.com/?cid=5505799854010942&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "plaza-san-antonio-hotel--spa-autograph-collection",
      "poi_latitude": "29.4188211",
      "poi_longitude": "-98.4891582",
      "poi_miles_from_property": "",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 210-229-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a116e3-4d68-727e-8d6a-593187dd67d4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a116e3-4d68-727e-8d6a-593187dd67d4",
        "storage_key": "property/6767906449167664/01a116e3-4d68-727e-8d6a-593187dd67d4.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJSRVfZ6lYXIYRPrKA7H6PEwA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    }
  ],
  "office_hours": [
    {
      "id": "ec_88f40b947b8d1e1f6993088f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "day": "MON",
      "open_time": "10:30",
      "close_time": "18:00"
    },
    {
      "id": "ec_7f37c5467f9e92d528ae0215",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_07e55e7fc057253af050e63f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9a3aa90596b7dfb446d645b1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_021244dd01ec2cafadd8198e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_6c838f8500719d4c3caaceec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_873c649ccaf2de5937815bde",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "rating": "5",
      "name": "Su",
      "text": "I’ve lived here for almost two years, and I genuinely love it. The management team is friendly, responsive, and proactive, and the maintenance team is incredibly fast at resolving any issues.\n\nThe apartments are beautiful, and the views are one of the best parts. The community is in a great location between downtown and Southtown, with awesome amenities like a rooftop pickleball and basketball court. The gym is also spacious and very well equipped.\n\nI’ve seen a few comments about safety, but in my experience this has been one of the safest apartment communities I’ve ever lived in. There are officers regularly patrolling the park area, and the garage has multiple security measures, including gated access and cameras throughout every level.",
      "date": "2026-02-07",
      "title": "false"
    },
    {
      "id": "ec_4ba716128f3003459100ac03",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "rating": "5",
      "name": "Christine Johnston",
      "text": "Living at The 68 feels pretty lucky, amazing views and in the middle of all the action, serene yet lively, an entertainment district in your front yard, couldn't ask for more. The Management Team is outstanding as well!",
      "date": "2026-05-24",
      "title": "false"
    },
    {
      "id": "ec_a9c12a8c19c02d454e12eb95",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "rating": "5",
      "name": "Ken Hay",
      "text": "Going on a year and been very satisfied with my decision to choose the ‘68. Even though the 1B apartment is on the smaller side, it works perfectly for me. The walls seem pretty thick, or I just have very quiet neighbors , as I never hear a peep from them. I also value the ability to walk out my door and have variety of dining options and the ability to walk either to downtown proper or King George district with ease. It can get a little noisy occasionally with festivals and such that happen in the nearby park, but I can also enjoy the music from the comfort of my patio at times.",
      "date": "2026-06-17",
      "title": "false"
    },
    {
      "id": "ec_45db36ff7fd4c2a1ac42f40f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "rating": "5",
      "name": "Hannah Johnson",
      "text": "This apartment is fantastic! The location is super convenient with easy access to downtown, parking and public transport. The unit itself is spacious, clean, and well-maintained, with plenty of natural light. The building amenities, like the gym and laundry in-unit, are a big plus. Plus, the management team is friendly, helpful, and responsive to any requests. Overall, a great place to call home!",
      "date": "2026-02-11",
      "title": "false"
    },
    {
      "id": "ec_3ddcd4b41b1141de59e84f89",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "rating": "5",
      "name": "jordan",
      "text": "Finally writing a review. I wanted to give myself time here at The 68’ before I wrote a review. I want to be accurate about how I rate my experience here. 1) just looking at every thing visually you can see The 68’ is well kept, very clean and modern. 10/10! 2) you must remember the location here is one of the best in downtown San Antonio, so it being located downtown you will have to give up space for quality and the experience of living in an awesome part of the city. 3) There is no pool but I’m not big on pools so it doesn’t bother me, but I do play basketball 🏀 and there is a court on the roof! The court is closed to the public and only for residents so that is a plus! 10/10!!!! 4) I love the parking they have available for residents,  it’s very secure and blocked from public parking and there are no break ins to residents cars because of the security. 4)Living  down town that’s a big plus 100/10!!!! 5) I live in a studio  apartment, it is very spacious I have a queen bed, a couch, a small 3 seat  dining room table and a dresser with a 75 inch TV! 10/10!!! when I was looking for an apt,  they all were a lil bigger but further away from my job so I was willing to give up space for location but still very spacious, no clutter. Over all I love this place the manager Bianca is very attentive to all the residents  and so is Maintance, which is highly unusual. I love it here I plan to renew for a couple more years,  maybe upgrade to a one bedroom. If not I’m happy either way!!",
      "date": "2023-09-27",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_05d714c4e20e7edde3d94e71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a11fdb-482c-7438-8806-7df3f95e884c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a11fdb-482c-7438-8806-7df3f95e884c",
        "storage_key": "property/6767906449167664/01a11fdb-482c-7438-8806-7df3f95e884c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "STUDIO 1BA W/ OPTIONAL ORI SYSTEM - 465SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=fGuN9E6i2xZ"
    },
    {
      "id": "ec_35a1b2668cce980fcff35158",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a11fdb-4713-755d-acee-4406bc4b63e1.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a11fdb-4713-755d-acee-4406bc4b63e1",
        "storage_key": "property/6767906449167664/01a11fdb-4713-755d-acee-4406bc4b63e1.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 555SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=eQd1i5yHtpP"
    },
    {
      "id": "ec_ba81dcaf72c7aa93e18b431f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167664/01a12f31-76e2-7629-95a4-7ae1bf682790.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a12f31-76e2-7629-95a4-7ae1bf682790",
        "storage_key": "property/6767906449167664/01a12f31-76e2-7629-95a4-7ae1bf682790.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 2BA - 1638SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=8wSh3Rqo9u3"
    }
  ],
  "faqs": [
    {
      "id": "custom_d32998ce-c16e-4772-8c60-a0bbae83c662",
      "question": "Does THE'68 have a pool? ",
      "answer": "We do not have a pool on our actual property; however, we partner with the nearby Spa Plaza San Antonio hotel and spa to give residents an exclusive wellness perk.\n\nThe Wellness Membership Details\nCost: $99 per month.\nPool Access: Full 7-day access to the resort-style pool.\nFitness Center: Unlimited access to their state-of-the-art gym.\nClasses: Entry to regular wellness classes.\nSpa Services: Special access and discounts on professional spa treatments.\nExtra Perks: Discounts on other select hotel and spa services.\nThis partnership gives you high-end resort perks just steps from home at a great monthly rate. We can tell you all about it when you visit or apply. ",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_e9627b88-37ac-4769-8f39-c10e83c7dd37",
      "question": "What is the best neighborhood to rent an apartment in San Antonio, TX?",
      "answer": "San Antonio has many distinct neighborhoods to choose from and has something for everyone. Here are some of the best places to live when you're looking for a San Antonio apartment for rent:\n\nDowntown (Hemisfair Area)\nTHE'68 is located in San Antonio's historic Hemisfair neighborhood, a vibrant downtown enclave situated directly inside a pristine urban park. Residents enjoy a dynamic lifestyle walking to world-renowned landmarks, interactive public gardens, and local cultural events right outside their front door.\n\nThe Pearl District\nA trendy urban neighborhood located just north of the downtown core along the river, this area is celebrated for its historic industrial architecture, chef-driven culinary scene, and lively weekend farmers market.\n\nSouthtown (King William)\nKnown as the city's premier arts district, this eclectic neighborhood features beautiful historic Victorian homes alongside an array of contemporary art galleries, local boutiques, and locally owned coffee shops.\n\nAlamo Heights\nAn affluent, well-established community located a short drive north of downtown, Alamo Heights offers top-rated local schools, quiet tree-lined streets, and upscale retail centers.",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_ceaaa13e-1cfe-431d-bf3e-8813ded81681",
      "question": "What makes living in San Antonio, TX unique?",
      "answer": "San Antonio offers a rare combination of rich multicultural history, booming economic opportunity, and scenic riverfront beauty that makes it one of the most culturally vibrant places to live in Texas. Whether you're looking for proximity to major corporate headquarters, world-class outdoor trails, or a short walk to top dining options, here are some of the unique features to consider:\n\nIdeal Location\nFrom THE'68, quick access to Interstate 37, US-281, I-35, and I-10 seamlessly connects residents to downtown employers, the San Antonio International Airport, and the broader metropolitan region in minutes.\n\nOutdoor Adventures\nThe historic San Antonio River Walk and Yanaguana Garden sit minutes from the property, giving residents immediate access to miles of beautiful trails, four acres of interactive play spaces, and peaceful reading gardens.\n\nPremium Living\nReflecting the city's exceptional affordability and outstanding quality of life, San Antonio was ranked the 11th best city in the nation for Gen Z residents in 2025 by CommercialCafe.\n\nLocal Community\nLiving at THE'68 puts residents steps from acclaimed park dining like Dough Pizzeria Napoletana and blocks from Biga on the Banks, alongside an array of on-site conveniences including a winery, a restaurant, and an ice creamery.",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_5ede0823-80f0-4a6a-bde8-e5e2583df2e3",
      "question": "What are some things to do in San Antonio, TX?",
      "answer": "There are many fun activities to do in San Antonio! THE'68's location at historic Hemisfair Park puts residents close to parks, cultural centers, dining, and quick access to all of downtown San Antonio's major attractions. Major attractions in the area include:\n\n- Tower of the Americas\n- Yanaguana Garden\n- The Alamo\n- San Antonio River Walk\n- La Villita Historic Village\n- Majestic Theatre\n- San Antonio Museum of Art\n- Briscoe Western Art Museum\n- Historic Market Square\n- San Antonio Missions National Historical Park",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_8f123532-c9c4-49d3-9019-fe1b5e1b47f6",
      "question": "How close is San Antonio, TX to major employers in the San Antonio metro?",
      "answer": "THE'68 is only minutes from the area's top employers. The property's proximity to Interstate 37 and US-281 gives easy access to healthcare, military, education, and corporate employers, like:\n\n- USAA headquarters\n- H-E-B Corporate\n- Valero Energy headquarters\n- San Antonio Medical Center\n- Toyota Motor Manufacturing Texas\n- Joint Base San Antonio (JBSA)\n- Methodist Healthcare System\n- Baptist Health System\n- University Health System\n- Wells Fargo Operations",
      "category": "",
      "source": "custom"
    },
    {
      "id": "custom_c4d0fd59-8175-4281-8cf4-924fdae6c1fe",
      "question": "What amenities does THE'68 offer?",
      "answer": "At THE'68, you'll find a variety of amenities that make living in vibrant San Antonio even better, such as:\n\nRooftop Basketball and Pickleball Court, Fitness Center, and Playground\nTHE'68 residents can maintain their active conditioning goals, enjoy friendly athletic competition on the rooftop court, or spend sunny afternoons at the outdoor play areas.\n\nOn-Site Winery, Restaurant, and Ice Creamery\nLiving at THE'68 connects you to exceptional dining and leisure opportunities right at home with a curated selection of culinary destinations situated inside the community.\n\nCity Views, Granite Countertops, and Energy-Efficient Appliances\nEvery beautifully appointed apartment home showcases breathtaking city views and a contemporary kitchen featuring premium granite countertops and energy-efficient appliances.\n\nParking Garage, Bicycle Storage, and Pet-Washing Stations\nThe community simplifies urban living with secured vehicle parking options, dedicated bicycle storage, and a specialized pet-washing facility for your four-legged companions.",
      "category": "",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a04a29-4a10-7438-8e19-8739bcda371d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "THE'68 Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664"
    },
    {
      "lead_collector_id": "01a04a29-4aa2-7059-9e8f-ff31228603d1",
      "lead_source": "LANDING_PAGE",
      "name": "THE'68 Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-san-antonio",
      "search_query": "apartments with in-unit laundry San Antonio",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover convenient living at THE'68 at Hemisfair in San Antonio. These apartments offer in-unit laundry facilities, elevating your living experience.",
      "page_copy": "Welcome to THE'68 at Hemisfair, located in the vibrant Hemisfair neighborhood of San Antonio. Our apartments not only provide in-unit laundry facilities but also offer a host of other amenities designed to enhance your lifestyle. Enjoy the luxury of doing laundry from the comfort of your apartment and say goodbye to shared laundry spaces. \n\nIn addition to the convenience of in-unit laundry, residents of THE'68 at Hemisfair can take advantage of a rooftop basketball and pickleball court, a recreation room, and more. Located in Bexar County, it's a perfect oasis in the city, offering a seamless blend of modern amenities and comfort. Discover why THE'68 at Hemisfair is the preferred choice for those seeking the ideal apartment home in San Antonio, TX.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry",
      "seo_description": "Discover THE'68 at Hemisfair in San Antonio with in-unit laundry. Enjoy modern amenities in the lively Hemisfair neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "luxury-city-view-apartments-bexar-county",
      "search_query": "luxury apartments with city views Bexar County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with City Views",
      "h2_subtitle": "Experience the elegance of luxury apartments at THE'68 at Hemisfair. Enjoy stunning city views right in Bexar County.",
      "page_copy": "At THE'68 at Hemisfair, we redefine luxury with breathtaking city views that are sure to inspire. Situated in the heart of Bexar County's Hemisfair neighborhood, our apartments offer unparalleled cityscapes that complement the stylish interiors. Revel in the sophistication and comfort of our homes, featuring premium amenities such as granite countertops and in-unit laundry, providing everything you need for an elevated lifestyle.\n\nBeyond the luxurious interiors and magnificent views, residents can take advantage of on-site features including a rooftop basketball and pickleball court, a recreation room, and bicycle storage. THE'68 at Hemisfair stands out as a premier choice for those seeking luxury apartments in San Antonio, TX, offering a perfect blend of convenience and opulence right in Bexar County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with City Views",
      "seo_description": "THE'68 at Hemisfair offers luxury city view apartments in Bexar County. Enjoy stunning vistas and premium amenities in the Hemisfair neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "apartments-with-pool-hemisfair-san-antonio",
      "search_query": "apartments with a pool in Hemisfair San Antonio",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Hemisfair",
      "h2_subtitle": "Enjoy exclusive amenities at THE'68, including a refreshing pool. Located in the heart of Hemisfair, San Antonio, our apartments redefine modern living.",
      "page_copy": "Discover the epitome of comfortable city living at THE'68 at Hemisfair, nestled in San Antonio's vibrant Hemisfair neighborhood. While our luxurious amenities include granite countertops and a rooftop basketball and pickleball court, residents here often seek out the enticing pool facilities in the local area to unwind and relax.\n\nTHE'68 at Hemisfair is ideally located for those who love community interaction and recreational activities. In addition to nearby pool access, our residents enjoy convenient on-site amenities like a recreation room, bicycle storage, and laundry facilities. Choose THE'68 at Hemisfair for an enriched apartment experience that perfectly captures the essence of San Antonio's urban allure in the heart of Bexar County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Hemisfair",
      "seo_description": "THE'68 at Hemisfair offers access to pool amenities in Hemisfair, San Antonio. Enjoy modern living in our well-appointed community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "pet-friendly-dog-parks-near-78205",
      "search_query": "pet-friendly communities with dog parks near 78205",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Community with Dog Parks",
      "h2_subtitle": "Welcome to THE'68 at Hemisfair, a pet-friendly community near 78205. Our residents enjoy easy access to nearby dog parks, making it perfect for pet owners.",
      "page_copy": "At THE'68 at Hemisfair, we believe that pets are family. Located in the dynamic Hemisfair neighborhood of San Antonio, our community is pet-friendly and ideally situated near several dog parks, ensuring your furry friend always has a place to romp and play. Enjoy the convenience of being just moments away from these canine havens in the 78205 area while living in a modern, comfortable setting.\n\nOur community offers more than just a great location. At THE'68 at Hemisfair, you'll find an array of amenities designed to enhance your lifestyle, including in-unit laundry, granite countertops, and a rooftop sports court. We understand the importance of convenience and comfort, which is why our bicycle storage and recreation room are available for all residents. Choose THE'68 at Hemisfair, where every member of your family, including the furry ones, can find their place.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Community with Dog Parks",
      "seo_description": "Live at THE'68 at Hemisfair a pet-friendly community near 78205 with access to dog parks. Enjoy modern comfort in San Antonio's Hemisfair neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "modern-apartments-fitness-center-78205",
      "search_query": "modern apartments with fitness center 78205",
      "category": "Amenity",
      "h1_title": "Modern Apartments with Fitness Center",
      "h2_subtitle": "Discover THE'68 at Hemisfair where modern living meets convenience. Located in zip code 78205, enjoy our fitness-focused amenities in San Antonio.",
      "page_copy": "Reside in style at THE'68 at Hemisfair, offering the perfect mix of modern living and active lifestyle opportunities right in the heart of San Antonio’s coveted 78205 area. Although our community at THE'68 doesn't feature an on-site fitness center, our location in the vibrant Hemisfair neighborhood gives you access to nearby facilities that cater to your workout needs. \n\nOur upscale apartments boast contemporary conveniences like granite countertops and expansive living spaces. Take advantage of our unique rooftop basketball and pickleball court, recreation room, and bicycle storage, all tailored to meet the dynamic needs of our residents. Live in comfort and luxury, enjoying easy access to a variety of fitness options and more, at THE'68 at Hemisfair.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with Fitness Center",
      "seo_description": "Discover modern living at THE'68 at Hemisfair near 78205. Enjoy fitness facilities nearby in San Antonio's vibrant Hemisfair neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "studio-apartments-hemisfair-san-antonio",
      "search_query": "studio apartments Hemisfair San Antonio",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Hemisfair",
      "h2_subtitle": "Explore studio living at THE'68 at Hemisfair in San Antonio's Hemisfair. Perfectly designed for those seeking efficiency and style.",
      "page_copy": "Experience the sleek, streamlined lifestyle of studio apartment living at THE'68 at Hemisfair, nestled in the cultural hub of Hemisfair, San Antonio. Our studio apartments are designed to offer the perfect balance of efficiency and comfort, complete with high-end finishes and modern amenities.\n\nTHE'68 at Hemisfair provides more than just a place to live; it's a vibrant community with a rooftop basketball and pickleball court, a lively recreation room, and practical features like bicycle storage and laundry facilities. Embrace urban living in the heart of San Antonio, where culture meets convenience, and enjoy the unique offerings of our studio apartment homes.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Hemisfair, San Antonio",
      "seo_description": "Find your new home at THE'68 at Hemisfair with our stylish studio apartments in Hemisfair, San Antonio. Enjoy modern amenities in the city's vibrant core.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-78205",
      "search_query": "1 bedroom apartments 78205",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in 78205",
      "h2_subtitle": "Discover the perfect 1 bedroom apartment at THE'68 at Hemisfair, where modern living meets comfort in the vibrant 78205 area of San Antonio.",
      "page_copy": "THE'68 at Hemisfair offers beautifully designed 1 bedroom apartments in the heart of San Antonio’s bustling 78205 area. Our residences provide the perfect sanctuary with modern features, including granite countertops and expansive, stylish interiors. Ideal for those who desire comfort without compromising on style, our apartments ensure a sophisticated living experience.\n\nSituated within the Hemisfair neighborhood, THE'68 at Hemisfair enhances your lifestyle with amenities like a rooftop basketball and pickleball court and an engaging recreation room. With bicycle storage and convenient laundry facilities on site, you’ll find everything you need to complement your urban living experience. Welcome to THE'68 at Hemisfair, where every aspect of home reflects quality and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in 78205",
      "seo_description": "Explore 1 bedroom apartments at THE'68 at Hemisfair in San Antonio's 78205. Enjoy modern amenities and a vibrant neighborhood in Hemisfair.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-bexar-county-tx",
      "search_query": "2 bedroom apartments Bexar County TX",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Bexar County",
      "h2_subtitle": "Explore spacious 2 bedroom apartments at THE'68 at Hemisfair, located in the heart of Bexar County, TX. Experience comfort and modern living in San Antonio.",
      "page_copy": "Find your ideal home at THE'68 at Hemisfair with our spacious 2 bedroom apartments, perfectly situated in Bexar County, TX. Each apartment is designed to accommodate your lifestyle with ample space and contemporary features, such as elegant granite countertops and open-concept floor plans. Whether you're working from home or hosting friends, our apartments provide a versatile environment tailored to fit your needs.\n\nNestled within the vibrant Hemisfair neighborhood of San Antonio, THE'68 at Hemisfair offers residents access to distinctive amenities, including a rooftop basketball and pickleball court, a dynamic recreation room, and convenient bicycle storage. Our location is just steps away from local attractions and dining options, making it easy to enjoy the best of Bexar County living. Embrace the perfect blend of modernity and community at THE'68 at Hemisfair.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Bexar County, TX",
      "seo_description": "Discover 2 bedroom apartments at THE'68 at Hemisfair in Bexar County, TX. Enjoy modern amenities and a vibrant San Antonio neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "apartments-near-san-antonio-college-tx",
      "search_query": "apartments near San Antonio College TX",
      "category": "School",
      "h1_title": "Apartments Near San Antonio College",
      "h2_subtitle": "Find your new home at THE'68 at Hemisfair, ideally located near San Antonio College, TX. Experience convenient living with great amenities.",
      "page_copy": "Positioned just a short distance from San Antonio College, THE'68 at Hemisfair is the perfect choice for individuals who desire a convenient yet vibrant lifestyle. Our apartments offer modern living spaces with fine details, such as granite countertops and spacious layouts, making it easy to feel at home.\n\nAt THE'68 at Hemisfair, located in the dynamic Hemisfair neighborhood, you have access to unmatched amenities designed to enhance everyday living. Enjoy an active lifestyle with our rooftop basketball and pickleball courts, relax in the recreation room, or utilize the bicycle storage facilities for a hassle-free commute. The close proximity to the college coupled with a lively community setting makes THE'68 at Hemisfair an exceptional place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near San Antonio College, TX",
      "seo_description": "Discover THE'68 at Hemisfair apartments near San Antonio College, TX. Enjoy modern living and amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "apartments-close-to-st-philips-college-bexar-county",
      "search_query": "apartments close to St. Philip's College Bexar County",
      "category": "School",
      "h1_title": "Apartments Near St. Philip's College",
      "h2_subtitle": "Live close to St. Philip's College at THE'68, located in Bexar County. Enjoy convenient access to education and modern amenities.",
      "page_copy": "THE'68 at Hemisfair offers the perfect living solution for individuals looking for apartments close to St. Philip's College in Bexar County. Our stylish, modern apartments feature luxurious granite countertops and spacious interiors, creating a welcoming home environment while being just a quick commute away from campus.\n\nLocated in the lively Hemisfair neighborhood of San Antonio, THE'68 at Hemisfair is packed with amenities, including a rooftop basketball and pickleball court, a vibrant recreation room, and bicycle storage. Our location ensures you are never far from local dining, entertainment, and cultural attractions, making THE'68 at Hemisfair ideal for those who want both proximity to education and an enriching lifestyle. Embrace the convenience and vibrancy that living at THE'68 at Hemisfair offers.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Philip's College, Bexar County",
      "seo_description": "Explore THE'68 at Hemisfair apartments near St. Philip's College, Bexar County. Enjoy modern amenities and convenient living in a vibrant neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "rentals-near-university-incarnate-word-san-antonio",
      "search_query": "rentals near University of the Incarnate Word San Antonio",
      "category": "School",
      "h1_title": "Rentals Near University of Incarnate Word",
      "h2_subtitle": "Discover rentals close to the University of the Incarnate Word in San Antonio. Enjoy modern living at THE'68 at Hemisfair.",
      "page_copy": "Located conveniently near the University of the Incarnate Word, THE'68 at Hemisfair offers premier rentals designed for individuals attending nearby. Our apartments feature high-end details such as granite countertops and spacious floor plans, providing a comfortable and stylish living environment.\n\nNestled in the vibrant Hemisfair neighborhood of San Antonio, THE'68 at Hemisfair not only offers a close proximity to campus but also provides access to excellent amenities. Residents enjoy our rooftop basketball and pickleball court, a well-equipped recreation room, and ample bicycle storage. This prime location ensures you're well-connected to local dining, shopping, and entertainment, making it an ideal place to live while pursuing academic and career goals.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near University of Incarnate Word, San Antonio",
      "seo_description": "Find modern rentals at THE'68 at Hemisfair near the University of the Incarnate Word in San Antonio. Enjoy excellent amenities and a great community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "apartments-by-st-marys-university-78205",
      "search_query": "apartments by St. Mary's University 78205",
      "category": "School",
      "h1_title": "Apartments by St. Mary's University 78205",
      "h2_subtitle": "Choose THE'68 at Hemisfair for top-tier apartments near St. Mary's University in the 78205 area. Enjoy modern amenities and a vibrant community.",
      "page_copy": "Discover unparalleled convenience by living at THE'68 at Hemisfair, located near St. Mary's University in the 78205 zip code. Our stylish apartments offer features such as granite countertops and open layouts, ensuring a comfortable living space for students and faculty members alike.\n\nSituated in the heart of San Antonio's dynamic Hemisfair neighborhood, our community provides an exceptional living experience. Residents enjoy exclusive access to a rooftop basketball and pickleball court, a vibrant recreation room, and practical bicycle storage facilities. With local attractions, dining, and entertainment just a moment away, THE'68 at Hemisfair is the perfect home base for those studying or working at St. Mary's University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by St. Mary's University, 78205",
      "seo_description": "Explore THE'68 at Hemisfair apartments by St. Mary's University, 78205. Enjoy luxury living with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "apartments-around-trinity-university-hemisfair",
      "search_query": "apartments around Trinity University Hemisfair",
      "category": "School",
      "h1_title": "Apartments Near Trinity University Hemisfair",
      "h2_subtitle": "Explore ideal apartments near Trinity University in the Hemisfair area. Experience vibrant living at THE'68 at Hemisfair.",
      "page_copy": "If you're searching for apartments around Trinity University, look no further than THE'68 at Hemisfair in the Hemisfair area. Our modern apartments are designed to offer the comfort and style you desire, complete with high-quality granite countertops and spacious layouts.\n\nLocated in the bustling neighborhood of Hemisfair, our community places you close to the action with excellent amenities like a rooftop basketball and pickleball court, a welcoming recreation room, and secure bicycle storage. Enjoy the convenience of urban living while having easy access to dining, cultural spots, and entertainment, making THE'68 at Hemisfair an ideal choice for those connected with Trinity University.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Trinity University Hemisfair",
      "seo_description": "Discover THE'68 at Hemisfair apartments near Trinity University in Hemisfair. Enjoy luxury amenities and a vibrant community close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "apartments-near-brooke-army-medical-center",
      "search_query": "apartments near Brooke Army Medical Center San Antonio",
      "category": "Hospital",
      "h1_title": "Apartments Near Brooke Army Medical Center",
      "h2_subtitle": "Find superb apartments near Brooke Army Medical Center in San Antonio. Choose THE'68 at Hemisfair for modern living with excellent amenities.",
      "page_copy": "THE'68 at Hemisfair offers outstanding apartment living just a convenient drive away from Brooke Army Medical Center in San Antonio. Our residences are thoughtfully equipped with modern features, including sleek granite countertops and expansive floor plans, perfectly accommodating both medical staff and hospital visitors.\n\nSituated in the vibrant Hemisfair neighborhood, THE'68 at Hemisfair provides a prime location enriched with top-notch amenities like a rooftop basketball and pickleball court, a sociable recreation room, and secure bicycle storage. Enjoy the ease of urban living with quick access to local dining and entertainment while staying close to Brooke Army Medical Center, making THE'68 at Hemisfair the perfect choice.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Brooke Army Medical Center",
      "seo_description": "Explore THE'68 at Hemisfair apartments near Brooke Army Medical Center, San Antonio. Enjoy modern amenities and a prime location in the Hemisfair neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "apartments-near-san-antonio-river-walk",
      "search_query": "apartments near san antonio river walk",
      "category": "Park",
      "h1_title": "Apartments Near San Antonio River Walk",
      "h2_subtitle": "Discover top-tier apartments near the iconic San Antonio Riverwalk. Live at THE'68 at Hemisfair and enjoy stylish homes in Hemisfair.",
      "page_copy": "Nestled in the lively neighborhood of Hemisfair, THE'68 at Hemisfair offers premium apartments just a stone's throw from the San Antonio Riverwalk. Our residences are adorned with luxurious features like granite countertops, providing comfort and style for every resident.\n\nAt THE'68 at Hemisfair, you're never far from the cultural pulse of the city. Enjoy community amenities such as a rooftop basketball and pickleball court, inviting recreation rooms, and handy bicycle storage. Perfectly positioned, living here means indulging in the vibrant scene of the River Walk with ease. Choose THE'68 at Hemisfair for a blend of convenience and modern living in the heart of San Antonio.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near San Antonio River Walk",
      "seo_description": "Stay close to the San Antonio Riverwalk at THE'68 at Hemisfair. Enjoy modern living with top-notch amenities in Hemisfair, just steps from city attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "the68-close-to-japanese-tea-garden",
      "search_query": "THE'68 close to japanese tea garden san antonio",
      "category": "Park",
      "h1_title": "THE'68 at Hemisfair Near Japanese Tea Garden",
      "h2_subtitle": "Experience life at THE'68 at Hemisfair, located a short drive from the serene Japanese Tea Garden in San Antonio. Discover stylish living in Hemisfair.",
      "page_copy": "Located just a convenient drive away from the tranquil Japanese Tea Garden, THE'68 offers residents a perfect blend of urban convenience and peaceful retreat. Set in the vibrant Hemisfair neighborhood, our apartments feature elegant granite countertops and spacious living areas designed with your lifestyle in mind.\n\nEnjoy top-notch community amenities at THE'68 at Hemisfair, including a rooftop basketball and pickleball court, an inviting recreation room, and convenient bicycle storage. This prime location allows you to explore the beauty of the Japanese Tea Garden while enjoying the urban energy of downtown San Antonio. Choose THE'68 for an unmatched living experience close to nature and city highlights.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "THE'68 at Hemisfair Near Japanese Tea Garden",
      "seo_description": "Live at THE'68 at Hemisfair, near San Antonio's Japanese Tea Garden. Enjoy modern amenities and a prime location, blending urban life with natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "rentals-near-san-antonio-botanical-garden",
      "search_query": "rentals by san antonio botanical garden",
      "category": "Park",
      "h1_title": "Rentals Near San Antonio Botanical Garden",
      "h2_subtitle": "Explore rentals close to the scenic San Antonio Botanical Garden. Experience comfort and style at THE'68 at Hemisfair in Hemisfair.",
      "page_copy": "THE'68 at Hemisfair offers rentals conveniently located near the beautiful San Antonio Botanical Garden, providing a perfect blend of nature and modern living. Our apartments in the lively Hemisfair neighborhood boast stylish interiors with features like granite countertops, designed for your comfort.\n\nResidents can enjoy a variety of community amenities, including a rooftop basketball and pickleball court, a sociable recreation room, and efficient bicycle storage. This ideal location lets you embrace the serene beauty of the Botanical Garden while staying connected to the vibrant culture of San Antonio. Choose THE'68 at Hemisfair for a harmonious balance of comfort, style, and accessibility.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near San Antonio Botanical Garden",
      "seo_description": "Discover rentals at THE'68 at Hemisfair, near the San Antonio Botanical Garden. Enjoy modern amenities in Hemisfair, close to natural and urban attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162466",
      "property_id": "6767906449167664",
      "source": "custom",
      "page_item_url": "apartments-near-woodlawn-lake-park",
      "search_query": "apartments near woodlawn lake park bexar county",
      "category": "Park",
      "h1_title": "Apartments Near Woodlawn Lake Park",
      "h2_subtitle": "Find ideal apartments near Woodlawn Lake Park in Bexar County. Experience serene living at THE'68 at Hemisfair in Hemisfair.",
      "page_copy": "Located in the heart of Bexar County, THE'68 at Hemisfair offers apartments just a short drive from the picturesque Woodlawn Lake Park. Our modern residences in Hemisfair feature granite countertops and ample living space, all designed with your comfort in mind.\n\nCommunity amenities at THE'68 at Hemisfair include a rooftop basketball and pickleball court, a lively recreation room, and dedicated bicycle storage. This excellent location provides quick access to the natural beauty of Woodlawn Lake Park while being situated in a bustling urban environment. At THE'68 at Hemisfair, relish the combination of tranquility and city life with our prime location and contemporary amenities.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Woodlawn Lake Park",
      "seo_description": "Discover THE'68 at Hemisfair near Woodlawn Lake Park. Enjoy modern living in Hemisfair, Bexar County, with easy access to both parks and city attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "brianna@repli360.com"
    },
    {
      "ID": "custom_gbp_utm",
      "type": "STRING",
      "value": "https://www.the68hemisfair.com?utm_source=propertywebsite"
    },
    {
      "ID": "custom_sem_utm",
      "type": "STRING",
      "value": "https://www.the68hemisfair.com?utm_source=repli360ppc"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12795355093"
    },
    {
      "ID": "custom_website_utm",
      "type": "STRING",
      "value": "https://www.the68hemisfair.com?utm_source=Google_Business-Profile"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KZ3W4PMF"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Prestige"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57322532164"
    },
    {
      "ID": "custom_lux_membership_url",
      "type": "STRING",
      "value": "https://www.dtsatx.com/luxmembership"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "1c3ff2b8-812b-11f0-ba35-0f7255aa4710"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bcd1707-74a8-4db5-b1de-bca46b2e676e"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-991-7987"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImNGY2EzZmJJOEVEU29oemhxUVV4Smc9PSIsInZhbHVlIjoib3ZtWkNJV1hKVHdmSk5DZk9qYm0ydz09IiwibWFjIjoiY2M3MjA0MDkzMzE4ZDFkNzliNzkzMGNhM2E3ZjljZDQ4ODIxMDM1NDU3YzhkMTQxNjYzYzVjNTk1MmI1NDg1OSJ9"
    }
  ],
  "custom_csm": "brianna@repli360.com",
  "custom_gbp_utm": "https://www.the68hemisfair.com?utm_source=propertywebsite",
  "custom_sem_utm": "https://www.the68hemisfair.com?utm_source=repli360ppc",
  "custom_repli_id": "12795355093",
  "custom_website_utm": "https://www.the68hemisfair.com?utm_source=Google_Business-Profile",
  "custom_google_gtm_id": "GTM-KZ3W4PMF",
  "custom_rollout_phase": "Phase 1",
  "custom_vibesites_theme": "Prestige",
  "custom_ads_subscription": "essential",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57322532164",
  "custom_lux_membership_url": "https://www.dtsatx.com/luxmembership",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "1c3ff2b8-812b-11f0-ba35-0f7255aa4710",
  "custom_eliseai_organization_id": "4bcd1707-74a8-4db5-b1de-bca46b2e676e",
  "custom_ppc_tracking_phone_number": "833-991-7987",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImNGY2EzZmJJOEVEU29oemhxUVV4Smc9PSIsInZhbHVlIjoib3ZtWkNJV1hKVHdmSk5DZk9qYm0ydz09IiwibWFjIjoiY2M3MjA0MDkzMzE4ZDFkNzliNzkzMGNhM2E3ZjljZDQ4ODIxMDM1NDU3YzhkMTQxNjYzYzVjNTk1MmI1NDg1OSJ9"
};

export const generatedAt = '2026-10-16T17:34:00.448Z';
